/**
 * Normalize roof type names from external sources (Norkart API, GPT) to canonical terms.
 */
const ROOF_TYPE_ALIASES = {
    'Valmettak': 'Valmtak',
    'Valmetak': 'Valmtak',
};

function normalizeRoofType(roofType) {
    if (!roofType) return roofType;
    return ROOF_TYPE_ALIASES[roofType] || roofType;
}

document.addEventListener('DOMContentLoaded', function () {
    let steps = document.querySelectorAll('.wds-roof-calculator__step');
    //let nextButtons = document.querySelectorAll('.wds-roof-calculator__next-btn:not(.wds-roof-calculator__next-btn--map)');
    let nextButtons = document.querySelectorAll('.wds-roof-calculator__next-btn');
    let prevButtons = document.querySelectorAll('.wds-roof-calculator__prev-btn'); // Assuming you add these
    let currentStep = 1;
    let wrapper = document.querySelector('.wds-roof-calculator__wrapper');
    let mapInstance = null;
    let roofPolygons = []; // Array to store roof polygons for management
    let mapNextBtn = document.querySelector('.wds-roof-calculator__next-btn--map');
    let mapPrevBtn = document.querySelector('.wds-roof-calculator__prev-btn--map');
    let mobileNav = document.querySelector('.wds-roof-calculator__mobile-nav');
    let SearchBar = document.querySelector('.map-placeholder .search-bar');
    let resetAddressBtn = document.querySelector('.wds-roof-calculator__reset-address');

    const calculatorState = {
        buildings: [], // Will hold building data from the API
        selections: { // Will hold user selections from the steps
            buildingType: null,
            roofAge: null,
            roofAgeNO: null,
            materials: {}, // Changed from material: null
            services: {}, // Changed from services: []
            projectStart: null,
            projectStartNO: null,
            contactInfo: {}
        },
        totals: { // Calculated totals
            totalArea: 0,
            totalPrice: 0
        },
        sessionData: {},
        selectedRoofFacets: [], // Will hold selected roof facets
        addressDetailsLoaded: false
    };

    let outputJson = {
        LeadID: null,
        SubmittedVia: 'tak-kalkulator',
        DateReceived: new Date().toISOString(),
        FullName: '',
        Phone: '',
        Email: '',
        FormMessage: '',
        Timeline: '',
        TimelineNO: '',
        //JobType: '',
        BuildingType: '',
        StreetAddress: '',
        PostalCode: '',
        City: '',
        Buildings: [],
        AIRecommendation: '',
        TechnicalSummary: '',
        JobSize: '',
        Total_EstimatedPrice_Takbytte: 0,
        Total_EstimatedPrice_Rehab: 0,
        TakfornyingPrisEstimert: 0,
        EstimationURL: '',
        RoofImageURL: '',
        Tech: {
            CoordinateX: null,
            CoordinateY: null,
            CalculatorVersion: 'v2',
            PricingModelVersion: 'v2.1',
            LandingPageURL: window.location.href,
            utmSource: '',
            utmMedium: '',
            utmCampaign: ''
        }
    };

    function populateStateFromSession() {
        const storedData = sessionStorage.getItem('norkartBuildingData');
        if (storedData) {
            try {
                const data = JSON.parse(storedData);
                console.log(data);
                calculatorState.sessionData = data;

                if (data.address) {
                    calculatorState.address = data.address;
                    // Show reset button when address is loaded from session
                    if (resetAddressBtn) {
                        resetAddressBtn.style.display = 'block';
                    }
                }

                // Update outputJson with address and coordinates
                outputJson.StreetAddress = data.address || '';
                outputJson.PostalCode = data.postnummer || '';
                outputJson.City = data.poststed || '';

                // Update coordinates in Tech object
                if (data.coordinates) {
                    outputJson.Tech.CoordinateX = parseFloat(data.coordinates.longitude) || null;
                    outputJson.Tech.CoordinateY = parseFloat(data.coordinates.latitude) || null;
                }

                updateSearchResultMessage({
                    success: true,
                    buildingCount: 0,
                    roofsCounter: 0,
                    address: data.address
                });

                updateHeaderStyle(false);

                toggleStep1Options(false);

                //hide search bar
                SearchBar.classList.add('hidden');

                initMap(data.coordinates);

            } catch (e) {
                console.error('Error parsing building data from session storage:', e);
            }
        }
    }

    function updateHeaderStyle(show = true) {
        const header = document.querySelector('.header');
        if (header) {
            header.style.display = show ? 'block' : 'none';
        }
    }

    let materialSelectionBuildingIndex = 0;
    let jobSelectionBuildingIndex = 0;
    let roofAgeSelectionBuildingIndex = 0;
    let serviceSelectionBuildingIndex = 0;
    let originalMaterialStepTitle = '';
    let originalServiceStepTitle = '';
    let currentBuildingIndexForMaterials = 0;
    let currentBuildingIndexForServices = 0;

    function getValidSelectedBuildingIndex(buildings, startIndex) {
        if (buildings[startIndex] && buildings[startIndex].selected) {
            return startIndex;
        }

        for (let i = startIndex + 1; i < buildings.length; i++) {
            if (buildings[i].selected) {
                return i;
            }
        }

        return -1;
    }
    function updateMainHeader() {
        if (!wdsCalculatorData || !wdsCalculatorData.stepHeadings) return;

        let mainHeader = document.querySelector('.wds-roof-calculator__header');
        if (!mainHeader) return;

        let mainTitleEl = mainHeader.querySelector('.wds-roof-calculator__main-title');
        let mainSubtitleEl = mainHeader.querySelector('.wds-roof-calculator__subtitle');

        const headings = wdsCalculatorData.stepHeadings[currentStep];
        if(currentStep === 8){
            let firstName = outputJson.FullName.split(' ')[0];
            headings.heading += ", " + firstName;
        }

        if (headings && mainTitleEl && mainSubtitleEl) {
            mainTitleEl.innerHTML = headings.heading;
            mainSubtitleEl.innerHTML = headings.subheading;

            if (mainHeader.style.display !== 'block') {
                mainHeader.style.display = 'block';
            }
        }

        /*
        if( (currentStep === 2 || currentStep === 3 || currentStep === 4 || currentStep === 5) && calculatorState.buildings.length > 1 ){
            const buildingNameSpan = document.createElement('span');
            buildingNameSpan.classList.add('wds-roof-calculator__step-title-building-name');
            if(currentStep === 2){
                if(!calculatorState.buildings[jobSelectionBuildingIndex].selected){
                    for (let index = 0; index < calculatorState.buildings.length; index++) {
                        const building = calculatorState.buildings[index];
                        if (jobSelectionBuildingIndex === index && building.selected) {
                            break;
                        } else {
                            jobSelectionBuildingIndex++;
                        }
                    }
                }
                buildingNameSpan.classList.add('building-'+(jobSelectionBuildingIndex+1));
                buildingNameSpan.textContent = ' ('+calculatorState.buildings[jobSelectionBuildingIndex].name+')';
            } else if(currentStep === 3 ){
                if(!calculatorState.buildings[roofAgeSelectionBuildingIndex].selected){
                    for (let index = 0; index < calculatorState.buildings.length; index++) {
                        const building = calculatorState.buildings[index];
                        if (roofAgeSelectionBuildingIndex === index && building.selected) {
                            break;
                        } else {
                            roofAgeSelectionBuildingIndex++;
                        }
                    }
                }
                buildingNameSpan.classList.add('building-'+(roofAgeSelectionBuildingIndex+1));
                buildingNameSpan.textContent = ' ('+calculatorState.buildings[roofAgeSelectionBuildingIndex].name+')';
            } else if(currentStep === 4 && calculatorState.buildings[materialSelectionBuildingIndex].selected){
                buildingNameSpan.classList.add('building-'+(materialSelectionBuildingIndex+1));
                buildingNameSpan.textContent = ' ('+calculatorState.buildings[materialSelectionBuildingIndex].name+')';
            } else if(currentStep === 5 && calculatorState.buildings[serviceSelectionBuildingIndex].selected){
                buildingNameSpan.classList.add('building-'+(serviceSelectionBuildingIndex+1));
                buildingNameSpan.textContent = ' ('+calculatorState.buildings[serviceSelectionBuildingIndex].name+')';
            }
            mainTitleEl.appendChild(buildingNameSpan);
        }
        */
        if (
            (currentStep === 2 ||
                currentStep === 3 ||
                currentStep === 4 ||
                currentStep === 5) &&
            calculatorState.buildings.length > 1
        ) {
            const buildings = calculatorState.buildings;
            const buildingNameSpan = document.createElement('span');
            buildingNameSpan.classList.add(
                'wds-roof-calculator__step-title-building-name'
            );

            let index = -1;

            if (currentStep === 2) {
                index = getValidSelectedBuildingIndex(
                    buildings,
                    jobSelectionBuildingIndex
                );
                if (index !== -1) {
                    jobSelectionBuildingIndex = index;
                }
            }

            if (currentStep === 3) {
                index = getValidSelectedBuildingIndex(
                    buildings,
                    roofAgeSelectionBuildingIndex
                );
                if (index !== -1) {
                    roofAgeSelectionBuildingIndex = index;
                }
            }

            if (currentStep === 4) {
                index = getValidSelectedBuildingIndex(
                    buildings,
                    materialSelectionBuildingIndex
                );
                if (index !== -1) {
                    materialSelectionBuildingIndex = index;
                }
            }

            if (currentStep === 5) {
                index = getValidSelectedBuildingIndex(
                    buildings,
                    serviceSelectionBuildingIndex
                );
                if (index !== -1) {
                    serviceSelectionBuildingIndex = index;
                }
            }

            if (index !== -1) {
                buildingNameSpan.classList.add('building-' + (index + 1));
                buildingNameSpan.textContent = ' (' + buildings[index].name + ')';
                mainTitleEl.appendChild(buildingNameSpan);
            }
        }
    }

    //step6 setup
    function setupStep6() {
        const step6 = document.querySelector('.wds-roof-calculator__step.active');
        if (!step6) return;

        //console.log('step6 setup');

        // Find all option cards in step 6
        const optionCards = step6.querySelectorAll('.wds-roof-calculator__option-card-icon');

        // If there are options and none are selected, select the first one
        if (optionCards.length > 0 && !step6.querySelector('.wds-roof-calculator__option-card-icon.selected')) {
            const firstOption = optionCards[0];
            firstOption.classList.add('selected');

            // If there's a radio input, check it
            const radioInput = firstOption.querySelector('input[type="radio"]');
            if (radioInput) {
                radioInput.checked = true;
            }

            // If there's a click handler that needs to be triggered
            firstOption.click();

            //make next-btn active
            const nextBtn = document.querySelector('.wds-roof-calculator__main-content.step-6 .wds-roof-calculator__mobile-nav .wds-roof-calculator__next-btn');
            if (nextBtn) {
                nextBtn.disabled = false;
            }
        }
    }

    //smooth scroll to top
    const root = document.scrollingElement || document.documentElement;

    function scrollTopSmooth(duration = 500) {
        // Try native smooth first
        try {
            root.scrollTo({ top: 0, behavior: 'smooth' });
        } catch (e) {
            // If Firefox throws (unlikely), fall back
            rafSmooth(duration);
            return;
        }

        // Fallback if native was ignored (next frame still not at 0)
        requestAnimationFrame(() => {
            if (root.scrollTop !== 0) rafSmooth(duration);
        });
    }

    function rafSmooth(duration) {
        const start = root.scrollTop;
        if (start === 0) return;
        const startTime = performance.now();

        function step(now) {
            const t = Math.min(1, (now - startTime) / duration);
            const eased = 1 - Math.pow(1 - t, 3); // easeOutCubic
            root.scrollTop = start * (1 - eased);
            if (t < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
    }
    //smooth scroll to top

    function goToStep(stepNumber) {

        /*
        // If trying to go to step 5, redirect to step 6 instead
        if (stepNumber === 5) {
            stepNumber = 6;
        }
         */

        if (stepNumber === 2 && !calculatorState.addressDetailsLoaded) {
            alert('Please wait for the address details to load before proceeding to the next step.');
            return;
        }

        scrollTopSmooth(500);

        steps.forEach(function (step) {
            step.style.display = 'none';
        });
        let targetStep = document.querySelector('.wds-roof-calculator__step[data-step="' + stepNumber + '"]');
        if (targetStep) {
            targetStep.style.display = 'block';
            currentStep = stepNumber;

            // Update step class on main content
            const wdsRoofCalculator = document.querySelector('.wds-roof-calculator');
            const mainContent = document.querySelector('.wds-roof-calculator__main-content');
            if (mainContent) {
                // Remove all step-* classes
                mainContent.className = mainContent.className.split(' ')
                    .filter(cls => !cls.startsWith('step-'))
                    .join(' ');
                // Add current step class
                mainContent.classList.add(`step-${currentStep}`);
                wdsRoofCalculator.classList.add(`step-${currentStep}`);
            }

            // remove class active from all steps
            steps.forEach(function (step) {
                step.classList.remove('active');
            });

            targetStep.classList.add('active');

            if (wrapper) {
                if (currentStep === 7) {
                    wrapper.classList.add('step-7-active');
                } else {
                    wrapper.classList.remove('step-7-active');
                }
            }
        }

        if (currentStep !== 1) {
            defaultMapCenter();
            //remove editing class from map and edit button
            const mapWrapper = document.querySelector('.wds-roof-calculator__map-wrapper');
            const editBtn = document.querySelector('.wds-edit-roof-btn');
            if (mapWrapper) {
                mapWrapper.classList.remove('editing', 'roof-editing-active');
            }
            if (editBtn) {
                editBtn.classList.remove('editing');
                const textSpan = editBtn.querySelector('.wds-edit-roof-text');
                if (textSpan) textSpan.textContent = 'Edit Roof';
            }
            //hide edit btns
            const editBtns = document.querySelectorAll('.wds-edit-roof-btn');
            editBtns.forEach(function (btn) {
                btn.style.display = 'none';
            });
        } else {
            //show edit btns
            const editBtns = document.querySelectorAll('.wds-edit-roof-btn');
            editBtns.forEach(function (btn) {
                btn.style.display = 'flex';
            });
        }

        /*
        if (currentStep === 6) {
            setupStep6();
        }
         */

        updateMainHeader();

        // Setup step-specific logic
        if (currentStep === 2) {
            setupJobTypeStep();
        } else if (currentStep === 3) {
            setupRoofAgeStep();
        } else if (currentStep === 4) {
            setupMaterialStep();
        } else if (currentStep === 5) {
            //setupServicesStep();
            setupStep6();
        }

        syncMobileNav();
    }

    function syncMobileNav() {
        // prev btn
        if (currentStep > 1) {
            if (mapPrevBtn) {
                mapPrevBtn.style.display = 'flex';
                mapPrevBtn.disabled = false;
            }
        } else {
            if (mapPrevBtn) {
                mapPrevBtn.style.display = 'none';
                mapPrevBtn.disabled = true;
            }
        }

        if (window.innerWidth < 1024) {
            if (currentStep === 4) {
                if (mobileNav) {
                    mobileNav.style.display = 'none';
                }
            } else {
                if (mobileNav) {
                    mobileNav.style.display = 'flex';
                }
            }
        }

        // set next btn disabled
        if (mapNextBtn) {
            if (currentStep === 5 || currentStep === 6) {
                mapNextBtn.disabled = false;
            } else {
                mapNextBtn.disabled = true;
            }
        }

        // change text of next btn
        let currentActiveStepNextBtn = document.querySelector('.wds-roof-calculator__step.active .wds-roof-calculator__next-btn');
        if (currentActiveStepNextBtn) {
            let currentActiveStepNextBtnText = currentActiveStepNextBtn.textContent;
            mapNextBtn.textContent = currentActiveStepNextBtnText;
        }
    }

    if (steps.length > 0) {
        // Option/Card Selection
        let optionCards = document.querySelectorAll('.wds-roof-calculator__option-card, .wds-roof-calculator__option-card-icon, .wds-roof-calculator__option-radio');
        optionCards.forEach(function (card) {
            card.addEventListener('click', function () {
                if (this.classList.contains('disabled')) {
                    return; // Do nothing if the card is disabled
                }
                // Remove selected from siblings
                let siblings = Array.from(this.parentNode.children).filter(function (child) {
                    return child !== this && child.classList.contains(this.classList[0]);
                }, this);
                siblings.forEach(function (sibling) {
                    sibling.classList.remove('selected');
                });
                this.classList.add('selected');

                // --- Update state based on selection ---
                const stepElement = this.closest('.wds-roof-calculator__step');
                if (!stepElement) return;

                const step = parseInt(stepElement.getAttribute('data-step'));
                const value = this.getAttribute('data-value') || this.querySelector('input[type="radio"]')?.value;

                if (step === 1) {
                    calculatorState.selections.buildingType = value;
                } else if (step === 3) {
                    calculatorState.selections.roofAge = value;
                    calculatorState.selections.roofAgeNO = this.querySelector('.wds-roof-calculator__radio-label').textContent;
                } else if (step === 5) {
                    calculatorState.selections.projectStart = value;
                    calculatorState.selections.projectStartNO = this.querySelector('.wds-roof-calculator__option-title').textContent;
                }

                // Enable the next button for the current step
                const nextBtn = stepElement.querySelector('.wds-roof-calculator__next-btn');
                const nextBtnMap = document.querySelector('.wds-roof-calculator__next-btn--map');
                //get length of seleted buildings from calculatorState
                let selectedBuildings = calculatorState.buildings.filter(building => building.selected);
                if (nextBtn && value && selectedBuildings.length > 0) {
                    nextBtn.disabled = false;
                    nextBtnMap.disabled = false;
                }

            });
        });

        // Material Accordion
        let materialSummaries = document.querySelectorAll('.wds-roof-calculator__material-summary');
        materialSummaries.forEach(function (summary) {
            summary.addEventListener('click', function () {
                let materialOption = this.closest('.wds-roof-calculator__material-option');

                if (materialOption.classList.contains('expanded')) {
                    materialOption.classList.remove('expanded');
                } else {
                    let allMaterialOptions = document.querySelectorAll('.wds-roof-calculator__material-option');
                    allMaterialOptions.forEach(function (opt) {
                        opt.classList.remove('expanded');
                    });
                    materialOption.classList.add('expanded');
                }
            });
        });
        //materials dropdown
        let dropdownBtn = document.querySelector('.wds-roof-calculator__dropdown-btn-text');
        dropdownBtn.addEventListener('click', function () {
            this.closest('.wds-roof-calculator__dropdown-btn').classList.toggle('active');
        });

        // Quantity Steppers
        let quantityButtons = document.querySelectorAll('.quantity-btn');
        quantityButtons.forEach(function (btn) {
            btn.addEventListener('click', function () {
                let input = this.parentElement.querySelector('.quantity-input');
                let oldValue = parseFloat(input.value);
                let newValue;
                if (this.classList.contains('plus')) {
                    newValue = oldValue + 1;
                } else {
                    newValue = (oldValue > 0) ? oldValue - 1 : 0;
                }
                input.value = newValue;

                // if value is more then 0, add class to .wds-roof-calculator__service-option
                if (newValue > 0) {
                    this.closest('.wds-roof-calculator__service-option').classList.add('has-selection');
                } else {
                    this.closest('.wds-roof-calculator__service-option').classList.remove('has-selection');
                }
            });
        });

        function processSelectedBuilding({
                                             buildings,
                                             currentIndex,
                                             saveFn,
                                             nextStep,
                                             onRepeat,
                                             onFinish
                                         }) {
            const currentBuilding = buildings[currentIndex];

            if (currentBuilding && currentBuilding.selected) {
                saveFn(currentBuilding);
            }

            for (let i = currentIndex + 1; i < buildings.length; i++) {
                if (buildings[i].selected) {
                    onRepeat(i);
                    return;
                }
            }

            if (onFinish) {
                onFinish();
            }

            goToStep(nextStep);
        }

        // Next Button Clicks
        nextButtons.forEach(function (button) {
            button.addEventListener('click', function (e) {
                e.preventDefault();
                scrollTopSmooth(500);
                /*
                let stepElement = this.closest('.wds-roof-calculator__step');
                let step = parseInt(stepElement.getAttribute('data-step'));
                 */
                let stepElement = document.querySelector('.wds-roof-calculator__main-content .wds-roof-calculator__step.active');
                let step = parseInt(stepElement.getAttribute('data-step'));
                let nextStep = currentStep + 1;

                //custom logic for job type step
                if (step === 2) {
                    //const selectedJobType = this.closest('.wds-roof-calculator__step').querySelector('.wds-roof-calculator__option-card.selected');
                    const selectedJobType = stepElement.querySelector('.wds-roof-calculator__option-card.selected');
                    if (!selectedJobType) return;

                    const jobTypeValue = selectedJobType.getAttribute('data-value');
                    const buildings = calculatorState.buildings;

                    processSelectedBuilding({
                        buildings,
                        currentIndex: jobSelectionBuildingIndex,

                        saveFn(building) {
                            building.JobType = jobTypeValue;
                        },

                        nextStep,

                        onRepeat(nextIndex) {
                            jobSelectionBuildingIndex = nextIndex;
                            setupJobTypeStep();
                        }
                    });

                    return;
                }

                // custom logic for roof_age
                if (step === 3) {
                    //const selectedRoofAge = this.closest('.wds-roof-calculator__step').querySelector('.wds-roof-calculator__option-radio.selected');
                    const selectedRoofAge = stepElement.querySelector('.wds-roof-calculator__option-radio.selected');
                    if (!selectedRoofAge) return;

                    const roofAgeValue = selectedRoofAge.querySelector('input[type="radio"]').value;
                    const roofAgeText = selectedRoofAge.querySelector('.wds-roof-calculator__radio-label').textContent;

                    const buildings = calculatorState.buildings;

                    processSelectedBuilding({
                        buildings,
                        currentIndex: roofAgeSelectionBuildingIndex,

                        saveFn(building) {
                            building.roofAge = roofAgeValue;
                            building.roofAgeNO = roofAgeText;
                        },

                        nextStep,

                        onRepeat(nextIndex) {
                            roofAgeSelectionBuildingIndex = nextIndex;
                            setupRoofAgeStep();
                        },

                        onFinish() {
                            prepareMaterials();
                        }
                    });

                    return;
                }

                // Custom logic for Material Step (Step 4)
                if (step === 4) {
                    //const selectedMaterial = this.closest('.wds-roof-calculator__material-option');
                    const selectedMaterial = stepElement.querySelector('.wds-roof-calculator__material-option.expanded');
                    if (!selectedMaterial) return;

                    const materialValue = selectedMaterial.getAttribute('data-value');
                    const buildings = calculatorState.buildings;

                    processSelectedBuilding({
                        buildings,
                        currentIndex: materialSelectionBuildingIndex,
                        saveFn(building) {
                            calculatorState.selections.materials[building.ByggId] = materialValue;
                        },
                        nextStep,
                        onRepeat(nextIndex) {
                            materialSelectionBuildingIndex = nextIndex;
                            setupMaterialStep();
                        },
                        onFinish() {
                            prepareMaterials();
                        }
                    });

                    return;
                }

                // Validation for Step 1: Building Type
                if (step === 1 && !calculatorState.selections.buildingType) {
                    alert('Please select a building type to continue.');
                    return;
                }

                // Validation for Step 2: Roof Age
                if (step === 3 && !calculatorState.selections.roofAge) {
                    alert('Please select the roof age to continue.');
                    return;
                }

                // Validation for Step 5: Project Start
                if (step === 5 && !calculatorState.selections.projectStart) {
                    alert('Please select a timeline to continue.');
                    return;
                }

                // Validation logic can be added here per step
                if (step === 5) {
                    let projectStartContainer = steps[step - 1].querySelector('.wds-roof-calculator__project-start-options');
                    if (projectStartContainer) {
                        let selectedCard = projectStartContainer.querySelector('.wds-roof-calculator__card.selected');
                        if (!selectedCard) {
                            alert('Please select a project start date.');
                            return;
                        }
                    }
                }

                if (step < steps.length) {
                    goToStep(nextStep);
                }
            });
        });

        // Initialize the calculator
        populateStateFromSession();
        goToStep(1);
    }

    // Function to reset address and update UI
    function resetAddress() {
        // Clear session storage
        sessionStorage.removeItem('norkartBuildingData');

        // Reset calculator state
        calculatorState.sessionData = {};
        calculatorState.address = null;
        calculatorState.addressDetailsLoaded = false;

        // Reset UI
        document.querySelector('.wds-roof-calculator__header').innerHTML = '';
        updateHeaderStyle(true);

        // Show search bar
        if (SearchBar) {
            SearchBar.classList.remove('hidden');
            const searchInput = SearchBar.querySelector('input[type="text"]');
            if (searchInput) searchInput.value = '';
        }

        // Reset map if it exists
        if (mapInstance) {
            mapInstance.remove();
            mapInstance = null;
        }

        // Hide reset button
        if (resetAddressBtn) {
            resetAddressBtn.classList.add('hidden');
        }

        //remove all classes from map placeholder element
        const mapPlaceholder = document.querySelector('.wds-roof-calculator__map-wrapper .map-placeholder');
        if (mapPlaceholder) {
            mapPlaceholder.classList.value = 'map-placeholder';
        }

        // Reset building type selection
        const buildingTypeCards = document.querySelectorAll('.wds-roof-calculator__option-card');
        buildingTypeCards.forEach(card => card.classList.remove('selected'));

        // Disable next button
        const nextBtn = document.querySelector('.wds-roof-calculator__step[data-step="1"] .wds-roof-calculator__next-btn');
        if (nextBtn) {
            nextBtn.disabled = true;
        }
    }

    // Add click handler for reset button
    if (resetAddressBtn) {
        resetAddressBtn.addEventListener('click', resetAddress);
    }
    //check if address exists then add hidden class to reset address button
    console.log(calculatorState.address);
    if (calculatorState.address) {
        resetAddressBtn.classList.add('hidden');
    }

    // Contact form validation
    let contactForm = document.querySelector('.wds-roof-calculator__contact-form');
    if (contactForm) {
        let fullNameInput = contactForm.querySelector('#full_name');
        let emailInput = contactForm.querySelector('#email_address');
        let phoneInput = contactForm.querySelector('#phone_number');
        let additionalInfo = contactForm.querySelector('#additional_info');
        let termsCheckbox = contactForm.querySelector('#terms');
        let submitBtn = contactForm.querySelector('.wds-roof-calculator__submit-btn');

        let validateEmail = function (email) {
            let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(email).toLowerCase());
        };

        let validatePhone = function (phone) {
            let cleanedPhone = String(phone).replace(/[\s\(\)-]/g, '');
            let re = /^((\+|00)?47)?\d{8}$/;
            return re.test(cleanedPhone);
        };

        let validateForm = function () {
            let isNameValid = fullNameInput.value.trim() !== '';
            let isEmailValid = validateEmail(emailInput.value);
            let isPhoneValid = validatePhone(phoneInput.value);
            let isAdditionalInfoValid = additionalInfo.value.trim() !== '';
            let areTermsAccepted = termsCheckbox.checked;

            if (fullNameInput.dataset.touched) {
                const formGroup = fullNameInput.closest('.wds-roof-calculator__form-group');
                if (formGroup) {
                    formGroup.classList.toggle('invalid', !isNameValid);
                }
            }
            if (emailInput.dataset.touched) {
                const formGroup = emailInput.closest('.wds-roof-calculator__form-group');
                if (formGroup) {
                    formGroup.classList.toggle('invalid', !isEmailValid);
                }
            }
            if (phoneInput.dataset.touched) {
                const formGroup = phoneInput.closest('.wds-roof-calculator__form-group');
                if (formGroup) {
                    formGroup.classList.toggle('invalid', !isPhoneValid);
                }
            }
            if (additionalInfo.dataset.touched) {
                const formGroup = additionalInfo.closest('.wds-roof-calculator__form-group');
                if (formGroup) {
                    formGroup.classList.toggle('invalid', !isAdditionalInfoValid);
                }
            }
            if (termsCheckbox.dataset.touched) {
                const formGroup = termsCheckbox.closest('.wds-roof-calculator__form-group');
                if (formGroup) {
                    formGroup.classList.toggle('invalid', !areTermsAccepted);
                }
            }

            if (isNameValid && isEmailValid && isPhoneValid && isAdditionalInfoValid && areTermsAccepted) {
                submitBtn.disabled = false;
                mapNextBtn.disabled = false;
            } else {
                submitBtn.disabled = true;
                mapNextBtn.disabled = true;
            }
        };
        const watched = [fullNameInput, emailInput, phoneInput, additionalInfo, termsCheckbox]
            .filter(Boolean);

        watched.forEach(function (input) {
            const touchHandler = function () {
                input.dataset.touched = true;
                validateForm();
            };
            input.addEventListener('input', validateForm);
            input.addEventListener('change', validateForm);
            input.addEventListener('blur', touchHandler, { once: true });
        });

        document.addEventListener('animationstart', function (e) {
            if (e.animationName === 'onAutoFillStart') {
                const el = e.target;
                validateForm();
            }
        }, true);

        contactForm.addEventListener('submit', function (e) {
            e.preventDefault();
            // Mark all as touched to show errors on all invalid fields
            [fullNameInput, emailInput, phoneInput, additionalInfo, termsCheckbox].forEach(function (input) {
                input.dataset.touched = true;
            });
            //validateForm();

            if (submitBtn.disabled) return;

            console.log('calculatorState');
            console.log(calculatorState);
            // Update each building in calculatorState with the latest calculations
            if (calculatorState && calculatorState.buildings) {
                calculatorState.buildings.forEach((building, index) => {
                    const selectedRoofs = (building.roofs || []).filter(roof => roof.selected);

                    if (selectedRoofs.length > 0) {
                        try {
                            // Calculate roof metrics
                            const { ComplexityScore, AIConfidence } = calculateRoofMetrics(selectedRoofs, building.RoofType);

                            // Update the building with the latest calculations
                            calculatorState.buildings[index] = {
                                ...building,
                                RoofType: building.RoofType,
                                ComplexityScore: parseFloat(ComplexityScore),
                                AIConfidence: AIConfidence
                            };
                        } catch (error) {
                            console.error('Error calculating roof metrics:', error);
                            // Keep the existing building data if calculation fails
                        }
                    }
                });
            }

            let forSend = prepareForSend(calculatorState);

            // Update contact info in state and outputJson
            forSend.selections.contactInfo = {
                full_name: fullNameInput.value,
                email_address: emailInput.value,
                phone_number: phoneInput.value,
                additional_info: additionalInfo.value,
                terms_accepted: termsCheckbox.checked
            };

            // Update outputJson with contact information
            outputJson.FullName = fullNameInput.value.trim();
            outputJson.Email = emailInput.value.trim();
            outputJson.Phone = phoneInput.value.trim();
            outputJson.FormMessage = additionalInfo.value.trim();
            outputJson.Timeline = calculatorState.selections.projectStart || 'ASAP';
            outputJson.TimelineNO = calculatorState.selections.projectStartNO || '';

            showGlobalLoader();
            defaultMapCenter();
            createMapScreenshot();

            // Add UTM parameters if available
            const urlParams = new URLSearchParams(window.location.search);
            outputJson.Tech.utmSource = urlParams.get('utm_source') || '';
            outputJson.Tech.utmMedium = urlParams.get('utm_medium') || '';
            outputJson.Tech.utmCampaign = urlParams.get('utm_campaign') || '';

            const formData = new FormData();
            formData.append('action', 'wds_submit_roof_lead');
            formData.append('nonce', wdsCalculatorData.nonce);
            formData.append('calculator_data', JSON.stringify(getSerializableCalculatorState(forSend)));
            //console.log('AI forSend');
            //console.log(formData);

            fetch(wdsCalculatorData.ajax_url, {
                method: 'POST',
                body: formData
            })
                .then(response => response.json())
                .then(data => {
                    if (data.success) {
                        if (data.data.ai_response.data) {
                            console.log('data.ai_response.data');
                            console.log(data.data.ai_response.data);
                            //const jsonBlock = (data.data.ai_response.data.AIRecommendation.match(/```json\s*([\s\S]*?)```/i) || [])[1] || '';
                            //const ai_data = JSON.parse(jsonBlock.trim());

                            calculatorState.ai_response = data.data.ai_response.data;
                        }

                        if (data.data.post_id) {
                            outputJson.LeadID = data.data.post_id;
                            outputJson.project_page = data.data.project_page_url + outputJson.LeadID +'/' + data.data.secure_hash + '/';
                            outputJson.edit_project_page = data.data.estimate_edit_page_url + outputJson.LeadID +'/' + data.data.secure_hash + '/';

                            // Update estimation URL with post ID
                            const url = new URL(window.location.href);
                            url.searchParams.set('estimation_id', data.data.post_id);

                            //activate temporary permanent redirect
                            let is_redirect = true;

                            // After setting calculatorState.buildings
                            updateBuildingsData(calculatorState.buildings);

                            const { ai_response } = calculatorState;
                            if (ai_response?.AIRecommendation) {
                                outputJson.AIRecommendation = ai_response.AIRecommendation;
                                outputJson.TechnicalSummary = ai_response.TechnicalSummary;
                            }
                            /**
                             * Fill outputJson
                             */
                            outputJson.DateReceived = new Date().toISOString();
                            outputJson.JobType = "Takbytte";
                            outputJson.Timeline = calculatorState.selections.projectStart ?? '';
                            outputJson.TimelineNO = calculatorState.selections.projectStartNO ?? '';
                            outputJson.BuildingType = calculatorState.selections.buildingType || 'Ukjent';
                            //outputJson.RoofAge = calculatorState.selections.roofAge;
                            //outputJson.RoofAgeNO = calculatorState.selections.roofAgeNO;

                            /**
                             * Reset session and calculations
                             */
                            calculatorState.sessionId = null;
                            calculatorState.calculations = null;
                            calculatorState.ai_response = null;
                            calculatorState.ai_request = null;
                            sessionStorage.removeItem('norkartBuildingData');

                            const { buildings} = calculatorState;
                            buildings.map((building, index) => {
                                if(building.selected){
                                    let prices = getPriceForBuilding(building);
                                }
                            });

                            setTimeout(async () => {
                                const htmlContent = await createEmailHtml();
                                const email = calculatorState.selections.contactInfo?.email_address;
                                //const name = calculatorState.selections.contactInfo?.full_name;
                                if (htmlContent && email) {
                                    await sendHtmlToEmail(htmlContent, email);
                                }
                                // Send updated data to server after a short delay
                                setTimeout(async () => {
                                    let buildingsHeights = await updateBuildingsHeights(wdsCalculatorData, calculatorState);
                                    sendToCRM(buildingsHeights);
                                    sendUpdatedDataToServer(true);
                                }, 500);
                            }, 1000);


                        }
                    } else {
                        alert('There was an error submitting your request. Please try again.');
                        submitBtn.textContent = 'Get Quote For Estimation';
                        validateForm();
                    }
                })
                .catch(error => {
                    hideGlobalLoader();
                    alert('There was a network error. Please try again.');
                    console.log(error);
                    submitBtn.textContent = 'Get Quote For Estimation';
                    validateForm();
                });
        });

        // Initial validation check for button state, without showing errors
        validateForm();
    }

    function sendUpdatedDataToServer(is_redirect = false) {

        const formData = new FormData();
        formData.append('action', 'wds_update_roof_lead');
        formData.append('nonce', wdsCalculatorData.nonce);
        formData.append('leadJson', JSON.stringify(outputJson));

        fetch(wdsCalculatorData.ajax_url, {
            method: 'POST',
            body: formData,
        })
            .then(response => {
                return response.json();
            })
            .then(data => {
                console.log('sendUpdatedDataToServer success:', data);
                if(is_redirect) {
                    window.location.href = outputJson.edit_project_page;
                }
            })
            .catch(error => {
                console.log('sendUpdatedDataToServer error:', error);
            });
    }

    function prepareForSend(state) {
        let forSend = {
            ...state,
            mapUrl: null
        };

        return forSend;
    }

    /**
     * Toggles the interactivity of the building type selection step.
     * @param {boolean} disabled True to disable, false to enable.
     */
    function toggleStep1Options(disabled) {
        const step1 = document.querySelector('.wds-roof-calculator__step[data-step="1"]');
        if (!step1) return;

        const optionCards = step1.querySelectorAll('.wds-roof-calculator__option-card');
        const nextBtn = step1.querySelector('.wds-roof-calculator__next-btn');

        optionCards.forEach(card => {
            card.classList.toggle('disabled', disabled);
        });

        if (nextBtn) {
            nextBtn.style.display = disabled ? 'none' : 'block';
            // Always ensure the button is disabled initially when options are enabled/disabled
            nextBtn.disabled = true;
        }
    }

    /**
     * Updates the search result message header.
     *
     * @param {object} data The data from the API response.
     * @param {boolean} data.success Whether the search was successful.
     * @param {string} data.address The address that was searched for.
     * @param {number} [data.buildingCount] The number of buildings found.
     * @param {number} [data.roofsCounter] The total number of roofs found.
     */
    function updateSearchResultMessage(data) {
        let header = document.querySelector('.wds-roof-calculator__header');
        let titleEl = header.querySelector('.wds-roof-calculator__main-title');
        let subtitleEl = header.querySelector('.wds-roof-calculator__subtitle');

        if (!header || !titleEl || !subtitleEl || !window.wdsCalculatorData) {
            return;
        }

        let messages = window.wdsCalculatorData.messages;
        let title;
        let subtitle;

        if (data.success) {
            // Show reset button when address is successfully set
            if (resetAddressBtn) {
                resetAddressBtn.style.display = 'block';
            }
            let buildingCount = data.buildingCount;
            let roofsCounter = data.roofsCounter;
            let address = data.address;

            if (buildingCount > 1) {
                buildingCount += ' bygninger'; // or 'buildings'
            } else {
                buildingCount += ' bygning'; // or 'building'
            }

            if (roofsCounter > 1) {
                roofsCounter += ' takflater'; // or 'roofs'
            } else {
                roofsCounter += ' takflate'; // or 'roof'
            }

            title = messages.search_success
                .replace('{$buildingCount}', buildingCount)
                .replace('{$roofsCounter}', roofsCounter)
                .replace('{$address}', address);

            subtitle = messages.search_description;

            // Persist this as the header for Step 1
            if (wdsCalculatorData.stepHeadings && wdsCalculatorData.stepHeadings[1]) {
                wdsCalculatorData.stepHeadings[1].heading = title;
                wdsCalculatorData.stepHeadings[1].subheading = subtitle;
            }
        } else {
            title = messages.search_unsuccess.replace('{$address}', '<strong>' + data.address + '</strong>');
            subtitle = ''; // Or some other message
        }

        titleEl.innerHTML = title;
        subtitleEl.innerHTML = subtitle;
        header.style.display = 'block';
    }

    function prepareMaterials(){
        let step4 = document.querySelector('.wds-roof-calculator__step[data-step="4"]');
        if (!step4) return;
        //remove all hidden classes
        let materials = step4.querySelectorAll('.wds-roof-calculator__material-option');
        materials.forEach(material => {
            material.classList.remove('hidden');
        });

        let JobType = calculatorState.buildings[materialSelectionBuildingIndex]['JobType'];

        materials.forEach(material => {
            if (JobType === wdsCalculatorData.JobType.renew_title) {
                if (material.getAttribute('data-takfornying') === '0') {
                    material.classList.add('hidden');
                }
            } else if (JobType === wdsCalculatorData.JobType.cleaning_title){
                if(material.getAttribute('data-cleaning') === '0'){
                    material.classList.add('hidden');
                }
            }
        });
    }
    function setupJobTypeStep() {
        const step2 = document.querySelector('.wds-roof-calculator__step[data-step="2"]');
        if (!step2) return;

        //reset selections
        const jobTypeOptions = step2.querySelector('.wds-roof-calculator__option-card.selected');
        if (jobTypeOptions) {
            jobTypeOptions.classList.remove('selected');
        }

        updateMainHeader();
    }

    function setupRoofAgeStep() {
        const step3 = document.querySelector('.wds-roof-calculator__step[data-step="3"]');
        if (!step3) return;

        //reset selections
        const roofAgeOptions = step3.querySelector('.wds-roof-calculator__option-radio.selected');
        if (roofAgeOptions) {
            roofAgeOptions.classList.remove('selected');
        }

        updateMainHeader();
    }

    function setupMaterialStep() {
        const step4 = document.querySelector('.wds-roof-calculator__step[data-step="4"]');
        if (!step4) return;

        // Reset all material options
        const allMaterialOptions = step4.querySelectorAll('.wds-roof-calculator__material-option');
        allMaterialOptions.forEach(opt => opt.classList.remove('expanded'));
        step4.querySelector('.wds-roof-calculator__options').classList.remove('has-selection');
        document.querySelector('.wds-roof-calculator__dropdown-btn').classList.remove('active');

        updateMainHeader();
    }

    function setupServicesStep() {
        const step5 = document.querySelector('.wds-roof-calculator__step[data-step="5"]');
        if (!step5) return;

        // Reset all quantity inputs
        const quantityInputs = step5.querySelectorAll('.quantity-input');
        quantityInputs.forEach(input => input.value = 0);

        updateMainHeader();
    }

    /**
     * Sends HTML estimate to email via AJAX
     * @param {string} htmlContent - HTML content to send
     * @param {string} email - Email address to send to
     */
    async function sendHtmlToEmail(htmlContent, email) {
        const formData = new FormData();
        formData.append('action', 'wds_send_html_to_email');
        formData.append('nonce', wdsCalculatorData.nonce);
        formData.append('html_content', htmlContent);
        formData.append('email', email);

        try {
            const response = await fetch(wdsCalculatorData.ajax_url, {
                method: 'POST',
                body: formData,
            });

            const data = await response.json();

            if (data.success) {
                console.log('HTML sent to email successfully:', data);
            } else {
                console.error('Failed to send HTML to email:', data);
            }
        } catch (error) {
            console.error('Error sending HTML to email:', error);
        }
    }

    /**
     * Converts font files to base64 for embedding in HTML
     * @param {string} fontPath - Path to the font file
     * @returns {Promise<string>} - Base64 encoded font data
     */
    async function convertFontToBase64(fontPath) {
        try {
            const response = await fetch(fontPath);
            const blob = await response.blob();
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = () => resolve(reader.result);
                reader.onerror = reject;
                reader.readAsDataURL(blob);
            });
        } catch (error) {
            console.warn('Failed to convert font to base64:', fontPath, error);
            return null;
        }
    }

    function getBuildingComplexity(building){
        //get complexity range for 1 building
        let complexityTitle = '';
        let complexityTooltip = '';
        let complexityRangeBars = 0;
        let complexityStyle = '';
        let color = '';
        let bg_color = '';
        if(building.ComplexityScore >= 1.00 && building.ComplexityScore < 1.05){
            complexityTitle = 'Enkelt tak';
            complexityTooltip = 'Standard saltak eller pulttak uten karnapper, arker eller spesielle tilpasninger';
            complexityRangeBars = 1;
            complexityStyle = 'wds-roof-calculator__complexity-range-wrap--1';
            color = '#84CC16';
            bg_color = '#F4FBE8';
        } else if(building.ComplexityScore >= 1.05 && building.ComplexityScore < 1.10){
            complexityTitle = 'Lett tilpasset';
            complexityTooltip = 'Tak med små tilpasninger som enkle gjennomføringer for pipe eller ventilasjon';
            complexityRangeBars = 2;
            complexityStyle = 'wds-roof-calculator__complexity-range-wrap--2';
            color = '#65A30D';
            bg_color = '#F6FBE7';
        } else if(building.ComplexityScore >= 1.10 && building.ComplexityScore < 1.15){
            complexityTitle = 'Noe komplekst';
            complexityTooltip = 'Tak med én karnapp/ark eller flere takflater som møtes i enkle vinkler';
            complexityRangeBars = 3;
            complexityStyle = 'wds-roof-calculator__complexity-range-wrap--3';
            color = '#FB923C';
            bg_color = '#FFF6ED';
        } else if(building.ComplexityScore >= 1.15 && building.ComplexityScore < 1.20){
            complexityTitle = 'Moderat komplekst';
            complexityTooltip = 'Flere karnapper, sammensatte takflater eller krevende tilpasninger mot fasade';
            complexityRangeBars = 4;
            complexityStyle = 'wds-roof-calculator__complexity-range-wrap--4';
            color = '#D97706';
            bg_color = '#FFF3E3';
        } else if(building.ComplexityScore >= 1.20 && building.ComplexityScore < 1.25){
            complexityTitle = 'Komplekst tak';
            complexityTooltip = 'Mange vinkler, flere arker/karnapper, eller kombinasjon av ulike takkonstruksjoner';
            complexityRangeBars = 5;
            complexityStyle = 'wds-roof-calculator__complexity-range-wrap--5';
            color = '#EA580C';
            bg_color = '#FFF2E8';
        } else if(building.ComplexityScore >= 1.25 && building.ComplexityScore < 1.30){
            complexityTitle = 'Svært komplekst';
            complexityTooltip = 'Avansert geometri med mange møtepunkter, store karnapper eller spesielle løsninger';
            complexityRangeBars = 6;
            complexityStyle = 'wds-roof-calculator__complexity-range-wrap--6';
            color = '#DC2626';
            bg_color = '#FFECEC';
        } else if(building.ComplexityScore >= 1.30){
            complexityTitle = 'Ekstremt komplekst';
            complexityTooltip = 'Unike arkitektoniske løsninger som krever spesialkompetanse og skreddersydde teknikker';
            complexityRangeBars = 7;
            complexityStyle = 'wds-roof-calculator__complexity-range-wrap--7';
            color = '#991B1B';
            bg_color = '#FCECEC';
        }

        let complexityRangeBarsHtml = '';
        for(let i = 0; i < 7; i++){
            let barActiveClass = '';
            if((i+1)<=complexityRangeBars){
                barActiveClass = ' active';
            }
            complexityRangeBarsHtml += `<div class="wds-roof-calculator__complexity-range-bar${barActiveClass}"></div>`;
        }

        return {
            title: complexityTitle,
            tooltip: complexityTooltip,
            rangeBars: complexityRangeBars,
            rangeBarsHtml: complexityRangeBarsHtml,
            style: complexityStyle,
            color: color,
            bg_color: bg_color
        };
    }

    function capitalizeFirstLetter(val) {
        return String(val).charAt(0).toUpperCase() + String(val).slice(1);
    }

    async function createEmailHtml(){
        let estimateEdit = wdsCalculatorData['estimateEdit'];
        const name = outputJson.FullName.split(' ');
        const first_name = name[0] ?? '';
        let logo_url = 'https://tak-kalkulator.no/wp-content/uploads/2025/12/estimate-logo.png';

        let formatted_Total_EstimatedPrice = new Intl.NumberFormat('fr-FR', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }).format(outputJson['Total_EstimatedPrice']);

        //buildings html
        let buildingsHtml = '';
        const mainBuildingLabel = estimateEdit?.global_labels?.main_building || 'Hovedhus';
        const isSingleBuilding = outputJson.Buildings.length === 1;
        outputJson.Buildings.forEach((building, index) => {
            if (typeof building.Material !== "undefined") {
                let formatted_EstimatedPrice_Total = new Intl.NumberFormat('fr-FR', {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0
                }).format(building.EstimatedPrice_Total);
                let buildingComplexity = getBuildingComplexity(building);
                let material = capitalizeFirstLetter(building.Material || '');
                let buildingLabel = isSingleBuilding ? mainBuildingLabel : (building.BuildingLabel || `Bygg ${String.fromCharCode(65 + index)}`);
                let jobType = building.JobType || 'Takbytte';
                let roofType = building.RoofType || 'Ukjent';
                buildingsHtml += `
            <!-- Building ${buildingLabel} -->
            <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%" style="border-collapse: initial; margin-bottom: 10px; background-color: #fafbfd; border-radius: 8px; padding: 13px 17px; border: 1px solid rgba(237, 241, 244, 0.3);" class="mobile-small-padding">
                <tr>
                    <td>
                        <p style="margin: 0 0 8px 0; font-size: 14px; color: #111827; font-weight: 600;">
                            <img src="https://tak-kalkulator.no/wp-content/uploads/2025/12/building.png" alt="" style="width: 18px; height: 18px; display: inline-block; vertical-align: middle; margin-right: 4px;" />
                            ${buildingLabel}
                            <span style="color: #9ca3af; margin: 0 6px;">→</span>
                            <img src="https://tak-kalkulator.no/wp-content/uploads/2025/12/building-blue.png" alt="" style="width: 16px; height: 16px; display: inline-block; vertical-align: middle; margin-right: 4px;" />
                            <span style="color: #4c6ef5;">${jobType}</span>
                            <span style="color: #9ca3af; margin: 0 6px;">→</span>
                            Kr ${formatted_EstimatedPrice_Total},-
                        </p>
                        <p style="margin: 0; font-size: 14px; color: #374151; line-height: 1.8;">
                            <img src="https://tak-kalkulator.no/wp-content/uploads/2025/12/area.png" alt="" style="width: 14px; height: 14px; display: inline-block; vertical-align: middle; margin-right: 4px;" />
                            ${building.RoofArea} m²
                            <span style="color: #d1d5db; margin: 0 6px;">·</span>
                            <img src="https://tak-kalkulator.no/wp-content/uploads/2025/12/roof_type.png" alt="" style="width: 14px; height: 14px; display: inline-block; vertical-align: middle; margin-right: 4px;" />
                            ${roofType}
                            <span style="color: #d1d5db; margin: 0 6px;">·</span>
                            <img src="https://tak-kalkulator.no/wp-content/uploads/2025/12/material.png" alt="" style="width: 14px; height: 14px; display: inline-block; vertical-align: middle; margin-right: 4px;" />
                            ${material}
                            <span style="color: #d1d5db; margin: 0 6px;">·</span>
                            <span style="color:${buildingComplexity.color}; background-color:${buildingComplexity.bg_color}; padding: 2px 8px; border-radius: 6px; font-size: 12px;">${buildingComplexity.title}</span>
                        </p>
                    </td>
                </tr>
            </table>
            `;
            }
        });

        let html = `<!DOCTYPE html>
<html lang="no">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Her er ditt takestimat</title>
</head>
<body style="margin: 0; padding: 0; background-color: #f9fafb; font-family: Inter, -apple-system, sans-serif;">
    <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%" style="background-color: #f9fafb; font-family: Inter, -apple-system, sans-serif;"">
        <tr>
            <td style="padding: 40px 20px;" class="mobile-no-padding">
                <style type="text/css">

                    @media only screen and (max-width: 600px) {
                        .mobile-no-padding {
                            padding: 0 !important;
                        }
                        .mobile-card-padding {
                            padding: 8px !important;
                        }
                        .mobile-small-padding {
                            padding: 12px 8px !important;
                        }
                    }
                </style>
                <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%" style="max-width: 640px; margin: 0 auto; background-color: #ffffff; border-radius: 12px; box-shadow: 0 1px 3px rgba(0,0,0,0.1);">
                    <tr>
                        <td style="padding: 32px;" class="mobile-card-padding">
                            
                            <!-- Logo Header -->
                            <div style="text-align: center; margin-bottom: 24px;">
                                <img src="${logo_url}" alt="Logo" style="width: 160px; height: auto; display: inline-block;" />
                            </div>

                            <!-- Header -->
                            <p style="margin: 0 0 8px 0; font-size: 14px; color: #6b7280;">${estimateEdit['header']['hello']} ${first_name}</p>
                            <h1 style="margin: 0 0 12px 0; font-size: 28px; color: #111827; font-weight: 700;">${estimateEdit['header']['title']}</h1>
                            <p style="margin: 0 0 24px 0; font-size: 16px; line-height: 1.6; color: #374151;">${estimateEdit['header']['description']}</p>

                            <!-- Price Card -->
                            <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%" style="border-collapse: initial; margin-bottom: 16px; background-color: #dbeafe; border-radius: 12px; padding: 20px;" class="mobile-small-padding">
                                <tr>
                                    <td>
                                        <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%">
                                            <tr>
                                                <td>
                                                    <p style="margin: 0 0 8px 0; font-size: 13px; color: #6b7280; font-weight: 500;">${estimateEdit['roof_summary']['estimate_title']}</p>
                                                </td>
                                                <td align="right">
                                                    <a href="${outputJson['edit_project_page']}" target="_blank" style="display: inline-flex; align-items: center; gap: 4px; color: #2563eb; font-size: 13px; font-weight: 500; text-decoration: none;">
                                                        <img src="https://tak-kalkulator.no/wp-content/uploads/2025/12/edit.png" alt="" style="width: 14px; height: 14px; display: inline-block; vertical-align: middle;" />
                                                        ${estimateEdit['roof_summary']['edit_label']}
                                                    </a>
                                                </td>
                                            </tr>
                                        </table>
                                        <h2 style="margin: 0; font-size: 32px; color: #1e3a8a; font-weight: 700;">Kr ${formatted_Total_EstimatedPrice},-</h2>
                                        <p style="margin: 4px 0 0 0; font-size: 12px; color: #6b7280;">${estimateEdit['roof_summary']['incl_vat']}</p>
                                    </td>
                                </tr>
                            </table>

                            <!-- Map -->
                            <div style="margin-bottom: 20px; border-radius: 12px; overflow: hidden; position: relative;">
                                <img src="${outputJson['RoofImageURL']}" alt="Kart" style="display: block; width: 100%; height: auto; border-radius: 12px;" />
                                <div style="position: absolute; bottom: 20px; left: 20px; background-color: rgba(255,255,255,0.95); padding: 12px 16px; border-radius: 10px; box-shadow: 0 2px 8px rgba(0,0,0,0.15);">
                                    <p style="margin: 0; font-size: 14px; color: #111827;">
                                        <img src="https://tak-kalkulator.no/wp-content/uploads/2025/12/marker.png" alt="" style="width: 16px; height: 16px; display: inline-block; vertical-align: middle; margin-right: 6px;" />
                                        ${outputJson['StreetAddress']}
                                    </p>
                                </div>
                            </div>

                            <!-- Buildings -->
                            <p style="margin: 0 0 10px 0; font-size: 13px; color: #6b7280; font-weight: 500;">${estimateEdit['roof_summary']['buildings_title']}</p>
                            
                            ${buildingsHtml}

                            <!-- CTA Button -->
                            <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%" style="margin-bottom: 20px;">
                                <tr>
                                    <td align="center">
                                        <a href="${outputJson['edit_project_page']}?send_to_crm=true" style="display: inline-block; background-color: #10b981; color: #ffffff; font-size: 16px; font-weight: 600; text-decoration: none; padding: 16px 32px; border-radius: 8px;">
                                            ${estimateEdit['roof_summary']['cta_label']}
                                        </a>
                                    </td>
                                </tr>
                            </table>

                            <!-- Quality Badges -->
                            <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%" style="margin-bottom: 24px;">
                                <tr>
                                    <td align="center" style="font-size: 13px; color: #6b7280; line-height: 1.8;">
                                        <img src="https://tak-kalkulator.no/wp-content/uploads/2025/12/cta_quality.png" alt="" style="width: 16px; height: 16px; display: inline-block; vertical-align: middle; margin-right: 4px;" />
                                        ${estimateEdit['roof_summary']['cta_quality']}
                                        <span style="margin: 0 12px;"></span>
                                        <img src="https://tak-kalkulator.no/wp-content/uploads/2025/12/cta_local.png" alt="" style="width: 16px; height: 16px; display: inline-block; vertical-align: middle; margin-right: 4px;" />
                                        ${estimateEdit['roof_summary']['cta_local']}
                                        <span style="margin: 0 12px;"></span>
                                        <img src="https://tak-kalkulator.no/wp-content/uploads/2025/12/cta_no_obligation.png" alt="" style="width: 16px; height: 16px; display: inline-block; vertical-align: middle; margin-right: 4px;" />
                                        ${estimateEdit['roof_summary']['cta_no_obligation']}
                                    </td>
                                </tr>
                            </table>

                            <!-- Recommendation -->
                            <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%" style="border-collapse: unset; background-color: #fafbfd; border-radius: 8px; padding: 16px; border: 1px solid rgba(237, 241, 244, 0.3);" class="mobile-small-padding">
                                <tr>
                                    <td style="vertical-align: top; width: 24px; padding-right: 12px;">
                                        <img src="https://tak-kalkulator.no/wp-content/uploads/2025/12/ai.png" alt="" style="width: 20px; height: 20px; display: block;" />
                                    </td>
                                    <td>
                                        <p style="margin: 0 0 8px 0; font-size: 14px; color: #111827; font-weight: 600;">${estimateEdit['ai']['title']}</p>
                                        <p style="margin: 0; font-size: 14px; line-height: 1.6; color: #6b7280;">${outputJson['AIRecommendation']}</p>
                                    </td>
                                </tr>
                            </table>

                        </td>
                    </tr>
                    
                    <!-- Footer -->
                    <tr>
                        <td style="text-align: center; padding: 24px 20px; background-color: #ffffff; border-top: 1px solid #e5e7eb; border-radius: 0 0 12px 12px; color: #6B7280; font-size: 13px;" class="mobile-card-padding">
                            <img src="${logo_url}" alt="Logo" width="120" style="margin-bottom: 8px; display: inline-block;" />
                            <p style="margin: 0 0 6px 0; color: #6B7280; font-size: 13px;">Smartere takbytte for norske hjem. En del av tak24.no</p>
                            <div style="margin-top: 6px;">
                                <a href="mailto:kalkulator@tak24.no" style="color: #1E3A8A; text-decoration: none; font-size: 13px;">kalkulator@tak24.no</a>
                            </div>
                        </td>
                    </tr>
                </table>
            </td>
        </tr>
    </table>
</body>
</html>
        `;
        return html;
    }


    /**
     * Calculates test prices for rehab and replace for a building
     */
    function getPriceForBuilding(building) {
        /**
         * ------
         */
        const buildingId = building.ByggId;

        /**
         * Complexity score
         */
        let complexityScore = 1;
        //complexityScore = parseFloat(calculatorState.ai_response?.ComplexityScore) || 1;
        complexityScore = parseFloat(building?.ComplexityScore) || 1;

        /**
         * Base prices
         */
        const basePricePerM2Replace = parseFloat(wdsCalculatorData.pricing.base_price_m2_replace) || 0;
        const basePricePerM2Rehab = parseFloat(wdsCalculatorData.pricing.base_price_m2_rehab) || 0;

        /**
         * Total area
         */
        const selectedRoofs = (building.roofs || []).filter(roof => roof.selected);
        /*
        console.log('building');
        console.log(building);
        console.log('selectedRoofs');
        console.log(selectedRoofs);
         */
        const area = Math.round(selectedRoofs.reduce((sum, roof) => sum + (parseFloat(roof.area) || 0), 0));


        /**
         * Roof age
         */
        //const roofAgeSelected = calculatorState.selections.roofAge;
        const roofAgeSelected = building.roofAge;
        const roofAgeMultiplier = parseFloat(wdsCalculatorData.pricing.roof_age_multipliers[roofAgeSelected]) || 1;

        //outputJson.Building.RoofAgeFactor = roofAgeMultiplier;

        /**
         * Building type
         */
        const buildingTypeSelected = calculatorState.selections.buildingType;
        const buildingTypeMultiplier = parseFloat(wdsCalculatorData.pricing.building_type_multipliers[buildingTypeSelected]) || 1;

        //outputJson.Building.BuildingType = buildingTypeSelected;
        //outputJson.Building.BuildingTypeFactor = buildingTypeMultiplier;

        /*
        outputJson.Buildings.push({
            RoofAgeFactor: roofAgeMultiplier,
            BuildingType: buildingTypeSelected,
            BuildingTypeFactor: buildingTypeMultiplier
        });
         */

        /**
         * Pitch
         */
        let maxPitch = 0;
        let minPitch = 0;
        const pitchSum = selectedRoofs.reduce((sum, roof) => {
            const roofPitch = roof.facetData && typeof roof.facetData.Helning !== 'undefined' ? parseFloat(roof.facetData.Helning) || 0 : 0;

            if (roofPitch > maxPitch) {
                maxPitch = roofPitch;
            }
            if (roofPitch < minPitch || minPitch === 0) {
                minPitch = roofPitch;
            }

            return sum + roofPitch;
        }, 0);

        const pitch = Math.round(pitchSum / selectedRoofs.length);

        /**
         * Material Price
         */
        const materialSlug = calculatorState.selections.materials[buildingId];
        console.log(wdsCalculatorData);
        const materialPriceRange = wdsCalculatorData.pricing.materials[materialSlug];
        console.log(materialPriceRange);
        const minPrice = parseFloat(materialPriceRange.min_price) || 0;
        const maxPrice = parseFloat(materialPriceRange.max_price) || 0;
        const materialPriceFinal = Math.round(minPrice + (maxPrice - minPrice) * (complexityScore - 1.0) / 0.3);

        /**
         * Add Ons
         */
        const services = calculatorState.selections.services[buildingId] || [];
        const servicesPricing = wdsCalculatorData.pricing.additional_services;
        const servicesPrices = {};

        let addOns = services.reduce((sum, service) => {
            let foundSlug = Object.keys(servicesPricing).find(slug => servicesPricing[slug].name === service.name);
            if (foundSlug) {
                let servicePricingItem = servicesPricing[foundSlug];
                let price = parseFloat(servicePricingItem.price) || 0;
                servicesPrices[service.name] = price * service.quantity;
                sum += price * service.quantity;

                outputJson.AddOns.push({
                    ServiceName: service.name,
                    Quantity: service.quantity,
                    Price: price,
                    Total: price * service.quantity,
                });
            }
            return sum;
        }, 0);

        /**
         * Full Replacement formula
         */
        let replace = area * (basePricePerM2Replace + materialPriceFinal) * complexityScore * roofAgeMultiplier * buildingTypeMultiplier + addOns;

        /**
         * Rehab formula
         */
        let rehab = area * (basePricePerM2Rehab + materialPriceFinal) * complexityScore * roofAgeMultiplier * buildingTypeMultiplier + addOns;

        /**
         * Additional multipliers by pitch and number of facets
         */
        let more_than_facets = '';
        let more_than_pitch = '';

        const facetsThreshold = parseInt(wdsCalculatorData.pricing.more_than_facets) || 4;
        const pitchThreshold = parseInt(wdsCalculatorData.pricing.more_than_pitch) || 45;

        if (selectedRoofs.length > facetsThreshold) {
            const facetsMultiplier = parseFloat(wdsCalculatorData.pricing.more_than_facets_multiplier) || 1.1;
            replace = replace * facetsMultiplier;
            rehab = rehab * facetsMultiplier;
            more_than_facets = ' | More than ' + facetsThreshold + ' facets then increase by ' + facetsMultiplier;
        }

        if (pitch > pitchThreshold) {
            const pitchMultiplier = parseFloat(wdsCalculatorData.pricing.more_than_pitch_multiplier) || 1.15;
            replace = replace * pitchMultiplier;
            rehab = rehab * pitchMultiplier;
            more_than_pitch = ' | More than ' + pitchThreshold + ' pitch then increase by ' + pitchMultiplier;
        }

        console.log(`[getPriceForBuilding] replace formula: Area: ${area} * (Base Price: ${basePricePerM2Replace} + Material Price: ${materialPriceFinal}) * Complexity Score: ${complexityScore} * Roof Age Multiplier: ${roofAgeMultiplier} * Building Type Multiplier: ${buildingTypeMultiplier} + Add Ons: ${addOns} ${more_than_facets} ${more_than_pitch}`);
        console.log(`[getPriceForBuilding] rehab formula: Area: ${area} * (Base Price: ${basePricePerM2Rehab} + Material Price: ${materialPriceFinal}) * Complexity Score: ${complexityScore} * Roof Age Multiplier: ${roofAgeMultiplier} * Building Type Multiplier: ${buildingTypeMultiplier} + Add Ons: ${addOns} ${more_than_facets} ${more_than_pitch}`);


        const pricingData = {
            buildingId: buildingId,
            rehab: Math.round(rehab).toLocaleString('en-US'),
            replace: Math.round(replace).toLocaleString('en-US'),
            totalArea: area.toString(),
            services: servicesPrices
        }
        if (!Array.isArray(wdsCalculatorData.pricingData)) {
            wdsCalculatorData.pricingData = [];
        }
        wdsCalculatorData.pricingData.push(pricingData);

        // Update the buildings data in outputJson
        updateBuildingsData(calculatorState.buildings);

        return pricingData;
    }

    // Add event listeners for "Back" button
    prevButtons.forEach(function (button) {
        button.addEventListener('click', function (e) {
            e.preventDefault();

            // On step 2 (JobType), if there are multiple buildings and we are not on the first one,
            // the back button should go to the previous building's material selection.
            if (currentStep === 2 && jobSelectionBuildingIndex > 0) {
                jobSelectionBuildingIndex = 0;
                setupJobTypeStep();
                return; // Exit here to prevent calling goToStep
            }

            // On step 3 (RoofAge), if there are multiple buildings and we are not on the first one,
            // the back button should go to the previous building's material selection.
            if (currentStep === 3 && roofAgeSelectionBuildingIndex > 0) {
                roofAgeSelectionBuildingIndex = 0;
                setupRoofAgeStep();
                return; // Exit here to prevent calling goToStep
            }


            // On step 4 (Materials), if there are multiple buildings and we are not on the first one,
            // the back button should go to the previous building's material selection.
            if (currentStep === 4 && materialSelectionBuildingIndex > 0) {
                materialSelectionBuildingIndex = 0;
                setupMaterialStep();
                return; // Exit here to prevent calling goToStep
            }

            // On step 5 (Services), similar logic to go back to previous building's services.
            if (currentStep === 5 && currentBuildingIndexForServices > 0) {
                currentBuildingIndexForServices = 0;
                setupServicesStep();
                return; // Exit here to prevent calling goToStep
            }
            if(currentStep === 6){
                currentStep = 5;
            }

            // For all other cases, or when on the first building of a multi-building step, go to the previous step.
            if (currentStep > 1) {
                jobSelectionBuildingIndex = 0;
                roofAgeSelectionBuildingIndex = 0;
                materialSelectionBuildingIndex = 0;
                currentBuildingIndexForServices = 0;
                goToStep(currentStep - 1);
            }
        });
    });

    function defaultMapCenter() {
        const storedData = sessionStorage.getItem('norkartBuildingData');
        if (storedData) {
            const data = JSON.parse(storedData);
            if (data.coordinates) {
                let center = [data.coordinates.latitude, data.coordinates.longitude];
                let zoom = 20;
                if (mapInstance) {
                    //mapInstance.setView(center, zoom);
                    if (roofPolygons.length > 0) {
                        const group = new L.featureGroup(roofPolygons);
                        mapInstance.fitBounds(group.getBounds(), {padding: [20, 20]});
                    }
                }
            }
        }
    }
    /**
     * Initializes the Leaflet map.
     * @param {object} [building] - Optional building object to center the map on.
     */
    function initMap(coordinates) {

        // Check if Leaflet is loaded
        if (typeof L === 'undefined') {
            console.error('Leaflet is not loaded.');
            return;
        }

        // If map is already initialized, clean up before creating a new one
        if (mapInstance) {
            clearRoofPolygons(); // Clear polygons before removing map
            mapInstance.remove();
            mapInstance = null;
        }

        const apiKey = window.wdsCalculatorData.apiKeys.map ?? '';

        if (!apiKey) {
            console.error('Map API key not found.');
            return;
        }

        const mapPlaceholder = document.querySelector('.wds-roof-calculator__map-wrapper .map-placeholder');
        if (!mapPlaceholder) {
            console.error('Map placeholder not found.');
            return;
        }

        let center, zoom;

        if (coordinates) {
            center = [coordinates.latitude, coordinates.longitude];
            zoom = 18;
        } else {
            center = [59.91678999657922, 10.728734135627747]; // Default to center of Norway
            zoom = 16;
        }

        mapInstance = L.map(mapPlaceholder, {
            zoomControl: false,
            scrollWheelZoom: false
        }).setView(center, zoom);

        const satelittLayer = L.tileLayer(
            `https://waapi.webatlas.no/maptiles/tiles/webatlas-orto-newup/wa_grid/{z}/{x}/{y}.jpeg?APITOKEN=${apiKey}`,
            {
                // attribution: ' 2020 Norkart AS/Geovekst og kommunene/OpenStreetMap/NASA/EEA CLC2006/Meti/Plan- og bygningsetaten, Oslo Kommune',
                maxZoom: 22,
                minZoom: 0,
            }
        );

        const kartLayer = L.tileLayer(
            `https://waapi.webatlas.no/maptiles/tiles/webatlas-gray-vektor/wa_grid/{z}/{x}/{y}.png?APITOKEN=${apiKey}`,
            {
                // attribution: ' 2020 Norkart AS/Geovekst og kommunene/OpenStreetMap/NASA/EEA CLC2006/Meti/Plan- og bygningsetaten, Oslo Kommune',
                maxZoom: 22,
                minZoom: 0,
            }
        );

        const baseMaps = {
            "Satelitt": satelittLayer,
            "Kart": kartLayer
        };

        kartLayer.addTo(mapInstance);

        L.control.layers(baseMaps, null, { position: 'topright' }).addTo(mapInstance);
        L.control.zoom({ zoomInTitle: 'Zoom inn', oomOutTitle: 'Zoom ut', position: 'topright' }).addTo(mapInstance);

        if (!document.querySelector('#leaflet-custom-controls-css')) {
            const style = document.createElement('style');
            style.id = 'leaflet-custom-controls-css';
            style.textContent = `
                .leaflet-top.leaflet-right {
                    display: flex;
                    flex-direction: column;
                    align-items: flex-end;
                    gap: 12px;
                }
                .leaflet-control-zoom {
                    margin-top: 52px !important;
                }
            `;
            document.head.appendChild(style);
        }

        const EditRoofControl = L.Control.extend({
            options: { position: 'topleft' },
            onAdd: function (map) {
                const container = L.DomUtil.create('div', 'leaflet-bar leaflet-edit-roof-control');
                container.innerHTML = `
                    <button type="button" class="wds-edit-roof-btn" tabindex="0">
                        <span class="wds-norkart-icomoon icon-map-edit" aria-hidden="true"></span>
                        <span class="wds-edit-roof-text">Rediger tak</span>
                    </button>
                `;
                L.DomEvent.disableClickPropagation(container);
                return container;
            }
        });
        mapInstance.addControl(new EditRoofControl());

        if (!document.querySelector('#wds-edit-roof-btn-style')) {
            const style = document.createElement('style');
            style.id = 'wds-edit-roof-btn-style';
            style.textContent = `
                .leaflet-edit-roof-control {
                    background: none !important;
                    box-shadow: none !important;
                    border: none !important;
                    margin: 0 0 0 8px !important;
                    padding: 0 !important;
                }
                .wds-edit-roof-btn {
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    background: #fff;
                    border: none;
                    border-radius: 999px;
                    box-shadow: 0 2px 8px rgba(16, 30, 54, 0.08);
                    padding: 8px 18px 8px 14px;
                    font-family: 'Poppins', Arial, sans-serif;
                    font-size: 16px;
                    font-weight: 500;
                    color: #111827;
                    cursor: pointer;
                    transition: box-shadow 0.15s;
                }
                .wds-edit-roof-btn:active, .wds-edit-roof-btn:focus {
                    box-shadow: 0 4px 12px rgba(16, 30, 54, 0.16);
                    outline: none;
                }
                .wds-edit-roof-icon {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
                .wds-edit-roof-text {
                    display: block;
                }
            `;
            document.head.appendChild(style);
        }

        setTimeout(() => {
            const btn = document.querySelector('.wds-edit-roof-btn');
            const mapWrapper = document.querySelector('.wds-roof-calculator__map-wrapper');
            if (btn && mapWrapper) {
                btn.addEventListener('click', function () {
                    btn.classList.toggle('editing');
                    mapWrapper.classList.toggle('editing');
                    mapWrapper.classList.toggle('roof-editing-active');
                    const textSpan = btn.querySelector('.wds-edit-roof-text');
                    if (btn.classList.contains('editing')) {
                        textSpan.textContent = 'Avslutt redigering'; // "Exit Editing"
                    } else {
                        textSpan.textContent = 'Rediger tak'; // "Edit Roof"
                    }
                });
            }
        }, 0);

        getDetailsByAdress();
    }

    /**
     * Clear all roof polygons from the map
     */
    function clearRoofPolygons() {
        roofPolygons.forEach(polygon => {
            if (mapInstance && mapInstance.hasLayer(polygon)) {
                mapInstance.removeLayer(polygon);
            }
        });
        roofPolygons = [];

        // Clear selected roof facets as well
        calculatorState.selectedRoofFacets = [];
    }

    // Building colors
    const BUILDING_COLORS = ['#3b82f6', '#10b981', '#f59e0b', '#ef4444', '#8b5cf6', '#06b6d4'];

    /**
     * Get polygon styles based on selection state
     * @param {boolean} isSelected - Whether the polygon is selected
     * @returns {Object} Leaflet polygon options
     */
    function getPolygonStyles(isSelected = false, buildingIndex = 0) {
        const baseColor = BUILDING_COLORS[buildingIndex % BUILDING_COLORS.length];
        let opacity = 0.9;
        if (!isSelected) {
            opacity = 0.3;
        }
        return {
            color: '#000000',
            weight: 1.5,
            opacity: 1,
            fillColor: baseColor,
            fillOpacity: opacity,
            dashArray: null
        };
    }

    /**
     * Toggle polygon selection state
     * @param {L.Polygon} polygon - The polygon to toggle
     * @param {Object} facetData - Facet data associated with the polygon
     */
    function togglePolygonSelection(polygon, facetData) {
        const isCurrentlySelected = polygon.isSelected || false;
        const newSelectedState = !isCurrentlySelected;
        const buildingId = facetData?.ByggId;
        let buildingRoofs = [];
        let buildingsWithSelectedRoofs = new Set();

        // Update polygon selection state
        polygon.isSelected = newSelectedState;
        polygon.facetData = facetData;

        // Apply new styles
        const newStyles = getPolygonStyles(newSelectedState, facetData.buildingIndex);
        polygon.setStyle(newStyles);

        // Update calculator state
        if (!calculatorState.selectedRoofFacets) {
            calculatorState.selectedRoofFacets = [];
        }

        if (newSelectedState) {
            // Add to selected facets
            if (!calculatorState.selectedRoofFacets.find(f => f.facetId === facetData.facetId)) {
                calculatorState.selectedRoofFacets.push({
                    facetId: facetData.facetId || `facet_${Date.now()}_${Math.random()}`,
                    facetData: facetData,
                    polygon: polygon
                });
            }
        } else {
            // Remove from selected facets
            calculatorState.selectedRoofFacets = calculatorState.selectedRoofFacets.filter(
                f => f.facetId !== (facetData.facetId || polygon.facetId)
            );
        }

        // Update the building's roof selection state
        if (buildingId && calculatorState.buildings) {
            const building = calculatorState.buildings.find(b => b.ByggId === buildingId);
            if (building && building.roofs) {
                // Update the specific roof's selected state
                const roof = building.roofs.find(r => r.id === facetData.Id);
                if (roof) {
                    roof.selected = newSelectedState;
                }
                
                // Get all roofs for this building
                buildingRoofs = building.roofs || [];
            }
        }

        // Count buildings with at least one selected roof
        if (calculatorState.buildings) {
            calculatorState.buildings.forEach(building => {
                if (building.roofs && building.roofs.some(roof => roof.selected)) {
                    buildingsWithSelectedRoofs.add(building.ByggId);
                    building.selected = true;
                } else {
                    building.selected = false;
                }
            });
        }

        //get value for current step
        const stepElement = document.querySelector('.wds-roof-calculator__step.active');
        let value = '';
        if (stepElement){
            //const step = parseInt(stepElement.getAttribute('data-step'));
            let card = stepElement.querySelector('.wds-roof-calculator__option-card.selected');
            if (card){
                value = card.getAttribute('data-value') || card.querySelector('input[type="radio"]')?.value;
            }
        }
        console.log();

        //set disabled for next button
        if(buildingsWithSelectedRoofs.size < 1){
            document.querySelector('.wds-roof-calculator__main-content.step-1 .wds-roof-calculator__next-btn').disabled = true;
        } else {
            if(value){
                document.querySelector('.wds-roof-calculator__main-content.step-1 .wds-roof-calculator__next-btn').disabled = false;
            }
        }

        // Update the search result message with current selection count
        if (calculatorState.address) {
            updateSearchResultMessage({
                success: true,
                address: calculatorState.address,
                buildingCount: buildingsWithSelectedRoofs.size,
                roofsCounter: calculatorState.selectedRoofFacets.length
            });
        }
    }

    /**
     * Add a roof polygon to the map and manage it
     * @param {Array} coordinates - Array of coordinate pairs
     * @param {Object} facetData - Original facet data
     * @param {number} index - Index of the facet for unique identification
     */
    function addRoofPolygon(coordinates, facetData = null, index = 0) {
        try {
            // Prepare facet data with unique ID
            const processedFacetData = {
                ...facetData,
                facetId: facetData.facetId || `facet_${index}_${Date.now()}`
            };

            // Get initial styles (selected state - all polygons start selected)
            const polygonStyles = getPolygonStyles(true, processedFacetData.buildingIndex);
            const polygon = L.polygon(coordinates, polygonStyles);

            // Set initial selection state (selected by default)
            polygon.isSelected = true;
            polygon.facetId = processedFacetData.facetId;
            polygon.facetData = processedFacetData;

            const getTooltipContent = () => {
                // Get building index from facetData or use a default of 1
                //const buildingNumber = (processedFacetData.buildingIndex || 0) + 1;
                const buildingLabel = `Bygg ${String.fromCharCode(65 + (processedFacetData.buildingIndex || 0))}`;
                const roofNumber = index + 1;
                return `
                         <div style="font-family: 'Poppins', sans-serif; min-width: 200px; padding: 8px;">
                             <div style="font-weight: 600; font-size: 14px; color: #111827; margin-bottom: 4px;">
                                 ${buildingLabel} - Tak ${roofNumber}
                             </div>
                             <div style="font-size: 12px; color: #6b7280;">
                                 Klikk for å inkludere eller ekskludere <br />dette taket fra prosjektet ditt
                             </div>
                         </div>
                     `;
            };

            // Add tooltip with simplified information
            if (processedFacetData) {
                if(window.innerWidth >= 768) {
                    polygon.bindTooltip(getTooltipContent(), {
                        permanent: false,
                        direction: 'auto',
                        offset: [0, 0],
                        opacity: 1,
                        className: 'roof-polygon-tooltip'
                    });
                }

                // Add custom CSS for tooltip if not already added
                if (!document.querySelector('#roof-tooltip-styles')) {
                    const tooltipStyles = document.createElement('style');
                    tooltipStyles.id = 'roof-tooltip-styles';
                    tooltipStyles.textContent = `
                         .roof-polygon-tooltip {
                             background: rgba(255,255,255, 0.7) !important;
                             /*border: 1px solid #e5e7eb !important;*/
                             border: none !important;
                             border-radius: 8px !important;
                             box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06) !important;
                             color: inherit !important;
                         }
                         .roof-polygon-tooltip::before {
                             border-top-color: rgba(255,255,255, 0.7) !important;
                         }
                         .leaflet-tooltip-top:before {
                             border-top-color: rgba(255,255,255, 0.7) !important;
                         }
                         .leaflet-tooltip-bottom:before {
                             border-bottom-color: rgba(255,255,255, 0.7) !important;
                         }
                         .leaflet-tooltip-left:before {
                             border-left-color: rgba(255,255,255, 0.7) !important;
                         }
                         .leaflet-tooltip-right:before {
                             border-right-color: rgba(255,255,255, 0.7) !important;
                         }
                     `;
                    document.head.appendChild(tooltipStyles);
                }
            }

            // Add click event for selection toggle
            polygon.on('click', function (e) {
                L.DomEvent.stopPropagation(e);
                const mapWrapper = document.querySelector('.wds-roof-calculator__map-wrapper');
                if (mapWrapper && mapWrapper.classList.contains('roof-editing-active')) {
                    togglePolygonSelection(polygon, processedFacetData);

                    const ByggId = processedFacetData.ByggId;
                    const roofId = processedFacetData.Id;
                    const building = calculatorState.buildings.find(b => b.ByggId === ByggId);
                    if (building) {
                        const roof = building.roofs.find(r => r.id === roofId);
                        if (roof) {
                            roof.selected = polygon.isSelected;
                        }
                    }
                    if(window.innerWidth < 768) {
                        let map_placeholder_tooltips = document.querySelector('.wds-roof-calculator__map-wrapper .wds-roof-calculator__mobile-tooltips');
                        if (map_placeholder_tooltips) {
                            //add div after map_placeholder
                            let div = document.createElement('div');
                            div.className = 'roof-polygon-tooltip';
                            div.innerHTML = getTooltipContent();
                            map_placeholder_tooltips.innerHTML = '';
                            if(!polygon.isSelected){
                                map_placeholder_tooltips.appendChild(div);
                            }
                        }
                    }
                }
            });

            // Add hover effects
            polygon.on('mouseover', function (e) {
                if (!polygon.isSelected) {
                    const hoverStyles = getPolygonStyles(false, processedFacetData.buildingIndex);
                    hoverStyles.fillOpacity = .7;
                    hoverStyles.weight = 1.5;
                    polygon.setStyle(hoverStyles);
                }
            });

            polygon.on('mouseout', function (e) {
                if (!polygon.isSelected) {
                    const normalStyles = getPolygonStyles(false, processedFacetData.buildingIndex);
                    polygon.setStyle(normalStyles);
                }
            });

            polygon.addTo(mapInstance);
            roofPolygons.push(polygon);

            // Add to selected facets since all polygons start selected
            if (!calculatorState.selectedRoofFacets) {
                calculatorState.selectedRoofFacets = [];
            }

            calculatorState.selectedRoofFacets.push({
                facetId: processedFacetData.facetId,
                facetData: processedFacetData,
                polygon: polygon
            });

            return polygon;
        } catch (error) {
            console.error('Error adding roof polygon:', error);
            return null;
        }
    }

    function getDetailsByAdress() {
        // Clear existing polygons before adding new ones
        clearRoofPolygons();

        const formData = new FormData();
        formData.append('action', 'wds_get_details_by_adress');
        formData.append('nonce', wdsCalculatorData.nonce);
        formData.append('sessionData', JSON.stringify(calculatorState.sessionData));

        fetch(wdsCalculatorData.ajax_url, {
            method: 'POST',
            body: formData
        }).then(response => response.json()).then(data => {
            if (data.success && data.data && data.data.details && data.data.details.roofData) {
                //console.log('data',data);

                const byggarealData = data.data.details.byggarealData;
                //console.log('byggarealData',byggarealData);
                const roofFacets = data.data.details.roofData;
                //console.log('roofFacets',roofFacets);

                let roofsCounter = roofFacets.length;

                const allByggIds = roofFacets.map(record => record.ByggId);
                const uniqueByggSet = new Set(allByggIds);
                let buildingCount = uniqueByggSet.size;

                updateSearchResultMessage({
                    success: true,
                    buildingCount,
                    roofsCounter,
                    address: calculatorState.sessionData.address
                });

                //get summ of Areal3D by id
                const areal3DSumByByggId = roofFacets.reduce((acc, item) => {
                    const byggId = item.ByggId;
                    acc[byggId] = (acc[byggId] || 0) + Number(item.Areal3D || 0);
                    return acc;
                }, {});

                roofFacets.sort((a, b) => {
                    return areal3DSumByByggId[b.ByggId] - areal3DSumByByggId[a.ByggId];
                });

                // unique ByggId
                let buildingIds = Array.from(new Set(roofFacets.map(f => f.ByggId).filter(Boolean)));

                // Create a map of ByggId to building index for quick lookup
                const buildingIndexMap = new Map();
                buildingIds.forEach((id, idx) => buildingIndexMap.set(id, idx));

                // Add buildingIndex to each facet
                roofFacets.forEach(facet => {
                    if (facet.ByggId && buildingIndexMap.has(facet.ByggId)) {
                        facet.buildingIndex = buildingIndexMap.get(facet.ByggId);
                    } else {
                        facet.buildingIndex = 0; // default to first building if ByggId is missing
                    }
                });

                // Sort roofFacets by Areal3D in descending order (largest first)
                roofFacets.sort((a, b) => {
                    const areaA = parseFloat(a.Areal3D) || 0;
                    const areaB = parseFloat(b.Areal3D) || 0;
                    return areaB - areaA; // Sort from largest to smallest
                });

                let successfulPolygons = 0;

                roofFacets.forEach((facet, index) => {
                    if (facet.Geometri) {
                        try {
                            const geometry = JSON.parse(facet.Geometri);

                            if (geometry.type === 'Polygon' && geometry.coordinates && geometry.coordinates[0]) {
                                const rawCoords = geometry.coordinates[0];
                                // Convert from GeoJSON format [lng, lat] to Leaflet format [lat, lng]
                                const polygonCoords = rawCoords.map(p => [p[1], p[0]]);

                                // Add polygon with facet data (which now includes buildingIndex)
                                const polygon = addRoofPolygon(polygonCoords, facet, index);

                                if (polygon) {
                                    successfulPolygons++;
                                }
                            } else {
                                console.warn(`Facet ${index + 1}: Invalid or non-polygon geometry`, geometry);
                            }
                        } catch (e) {
                            console.error(`Error parsing Geometri JSON for facet ${index + 1}:`, e, facet.Geometri);
                        }
                    } else {
                        console.warn(`Facet ${index + 1}: No Geometri data`, facet);
                    }
                });

                // Fit map to show all polygons if any were added
                if (roofPolygons.length > 0) {
                    const group = new L.featureGroup(roofPolygons);
                    mapInstance.fitBounds(group.getBounds(), { padding: [20, 20] });
                }

                // Create a map of ByggId -> ByggType
                const byggTypeMap = new Map();

                roofFacets.forEach(facet => {
                    if (facet.ByggId && facet.ByggType && !byggTypeMap.has(facet.ByggId)) {
                        byggTypeMap.set(facet.ByggId, facet.ByggType);
                    }
                });

                const buildings = buildingIds.map((ByggId, idx) => {
                    const buildingFacets = roofFacets.filter(f => f.ByggId === ByggId);
                    const roofs = buildingFacets.map((facet, roofIndex) => ({
                        id: facet.Id,
                        selected: true,
                        area: facet.Areal3D,
                        facetData: facet,
                        buildingIndex: idx,
                        roofIndex: roofIndex
                    }));
                    const totalRoofArea = roofs.reduce((sum, r) => sum + (parseFloat(r.area) || 0), 0);
                    const name = `Bygg ${String.fromCharCode(65 + idx)}`;
                    return {
                        ByggId,
                        name,
                        selected: true,
                        ByggType: byggTypeMap.get(ByggId) || null,
                        roofs,
                        totalRoofArea,
                        Floors: byggarealData[ByggId].AntallEtasjer,
                        RoofType: normalizeRoofType(byggarealData[ByggId].Taktype),
                        buildingIndex: idx
                    };
                });

                calculatorState.buildings = buildings;
                calculatorState.addressDetailsLoaded = true;

                //console.log('calculatorState.buildings',calculatorState.buildings);

            } else {
                console.warn('No roof data found in API response', data);
            }
        }).catch(error => {
            console.error('Error fetching details by address:', error);
        });
    }

    function getSerializableCalculatorState(state) {
        const { mapUrl, ...serializableState } = state;

        return {
            ...serializableState,
            selectedRoofFacets: state.selectedRoofFacets
                ? state.selectedRoofFacets.map(f => ({
                    facetId: f.facetId,
                    facetData: f.facetData
                }))
                : []
        };
    }

    function showGlobalLoader() {
        const loader = document.getElementById('wds-global-loader');
        if (loader) {
            loader.style.display = 'flex';
        }
    }

    function hideGlobalLoader() {
        const loader = document.getElementById('wds-global-loader');
        if (loader) {
            loader.style.display = 'none';
        }
    }

    // Function to create map screenshot using leaflet-simple-map-screenshoter
    function createMapScreenshot() {
        if (!mapInstance) {
            console.warn('Map instance not available for screenshot');
            return;
        }

        // Check if leaflet-simple-map-screenshoter is available
        if (typeof L.simpleMapScreenshoter === 'undefined') {
            console.error('leaflet-simple-map-screenshoter plugin not loaded');
            return;
        }

        try {
            // Create screenshoter instance
            const screenshoter = L.simpleMapScreenshoter().addTo(mapInstance);

            // Take screenshot
            screenshoter.takeScreen('image/png').then(function (blob) {
                // Convert blob to dataURL (base64)
                const reader = new FileReader();
                reader.onloadend = function () {
                    calculatorState.mapUrl = reader.result; // data:image/png;base64,...
                    console.log('Map screenshot saved as dataURL in calculatorState.mapUrl');

                    //ajax save_img_to_file
                    const formData = new FormData();
                    formData.append('action', 'wds_save_img_to_file');
                    formData.append('nonce', wdsCalculatorData.nonce);
                    formData.append('img', reader.result);
                    fetch(wdsCalculatorData.ajax_url, {
                        method: 'POST',
                        body: formData
                    }).then(response => response.json()).then(data => {
                        console.log('Screenshot saved successfully to a file');
                        outputJson.RoofImageURL = data.data.url;
                    }).catch(error => {
                        console.error('Error saving screenshot:', error);
                    });
                };

                reader.readAsDataURL(blob);

                // Remove screenshoter from map
                mapInstance.removeControl(screenshoter);
            }).catch(function (error) {
                console.error('Screenshot error:', error);
            });
        } catch (error) {
            console.error('Error creating map screenshot:', error);
        }
    }

    function sendToCRM(buildingsHeights) {
        const formData = new FormData();
        //new outputJson
        let newoutputJson = buildNewOutputJson(outputJson, calculatorState, buildingsHeights);
        formData.append('action', 'wds_get_quote_ajax');
        formData.append('nonce', wdsCalculatorData.nonce);
        formData.append('data', JSON.stringify(newoutputJson));
        // send data to server
        fetch(window.wdsCalculatorData.ajax_url, {
            method: 'POST',
            body: formData
        })
            .then(function (response) {
                return response.json();
            })
            .then(function (response) {
                console.log(response);
            }).catch(function (error) {
            console.error('Error:', error);
        });
    }

    /*
    if (mapNextBtn) {
        mapNextBtn.addEventListener('click', function (e) {
            e.preventDefault();
            let activeStep = document.querySelector('.wds-roof-calculator__step.active');
            if (activeStep) {
                let currentStep = parseInt(activeStep.dataset.step);
                if (currentStep === 1) {
                    currentStep = 2;
                } else if (currentStep === 2) {
                    currentStep = 3;
                } else if (currentStep === 3) {
                    currentStep = 4;
                } else if (currentStep === 4) {
                    currentStep = 6;
                } else if (currentStep === 6) {
                    currentStep = 7;
                }
                goToStep(currentStep);
            }
        });
    }
     */

    // Function to update building data in outputJson
    function updateBuildingsData(buildings) {
        console.log('start updateBuildingsData');
        if (!Array.isArray(buildings) || buildings.length === 0) return;

        outputJson.Buildings = buildings.map((building, index) => {
            // Calculate total area from selected roofs
            const selectedRoofs = (building.roofs || []).filter(roof => roof.selected);
            const totalArea = Math.round(selectedRoofs.reduce((sum, roof) =>
                sum + (parseFloat(roof.area) || 0), 0
            ));

            // Calculate roof metrics
            const { ComplexityScore, AIConfidence } = calculateRoofMetrics(selectedRoofs, building.RoofType);

            const buildingId = building.ByggId;

            // 1. Find the pricingData entry for this buildingId
            const priceEntry = (wdsCalculatorData.pricingData || [])
                .find(item => item.buildingId === buildingId);

            // 2. Parse rehab & replace (takbytte) prices, removing commas
            const rehabPrice   = priceEntry
                ? parseInt(priceEntry.rehab.replace(/,/g, ''), 10)
                : 0;
            const replacePrice = priceEntry
                ? parseInt(priceEntry.replace.replace(/,/g, ''), 10)
                : 0;
            const TakfornyingPrice   = totalArea * parseFloat(wdsCalculatorData.pricing.base_price_m2_takfornying) || 0;
            const cleaningPrice   = getCalcCleaningPrice(totalArea, ComplexityScore);
            let totalPrice = replacePrice;
            if(building.JobType === wdsCalculatorData.JobType.rehab_title){
                totalPrice = rehabPrice;
            } else if(building.JobType === wdsCalculatorData.JobType.renew_title){
                totalPrice = TakfornyingPrice;
            } else if(building.JobType === wdsCalculatorData.JobType.cleaning_title){
                totalPrice = cleaningPrice;
            }

            const buildingData = {
                BuildingLabel: (buildings.length === 1)
                    ? (wdsCalculatorData?.estimateEdit?.global_labels?.main_building || 'Hovedhus')
                    : `Bygg ${String.fromCharCode(65 + index)}`,
                RoofArea: totalArea,  // Use the calculated total area
                Floors: building.Floors,
                RoofType: normalizeRoofType(building.RoofType) || 'Ukjent',
                JobType: building.JobType || 'Takbytte',
                RoofAge: building.roofAge,
                RoofAgeNO: building.roofAgeNO,
                AIConfidence: AIConfidence,
                Material: calculatorState.selections.materials[buildingId],
                ComplexityScore: parseFloat(ComplexityScore),
                EstimatedPrice_Takbytte: replacePrice,
                EstimatedPrice_Rehab: rehabPrice,
                EstimatedPrice_Takfornying: TakfornyingPrice,
                EstimatedPrice_Cleaning: cleaningPrice,
                EstimatedPrice_Total: totalPrice,
                RoofFacets: []
            };

            // Rest of the function remains the same...
            if (building.roofs && Array.isArray(building.roofs)) {
                buildingData.RoofFacets = building.roofs
                    .filter(roof => roof.selected)
                    .map((roof, i) => ({
                        Id: roof.id || i + 1,
                        Areal: parseFloat(roof.area) || 0,
                        Helning: parseFloat(roof.facetData?.Helning) || 0,
                        Materiale: calculatorState.selections.materials[buildingId],
                        Retning: roof.facetData?.Retning || '',
                        Lengde: parseFloat(roof.facetData?.Lengde) || 0,
                        Bredde: parseFloat(roof.facetData?.Bredde) || 0
                    }));
            }

            return buildingData;
        });

        outputJson.Total_EstimatedPrice_Takbytte = outputJson.Buildings.reduce(
            (sum, building) => sum + (building.EstimatedPrice_Takbytte || 0), 0
        );

        outputJson.Total_EstimatedPrice_Rehab = outputJson.Buildings.reduce(
            (sum, building) => sum + (building.EstimatedPrice_Rehab || 0), 0
        );

        outputJson.TakfornyingPrisEstimert = Math.round(outputJson.Total_EstimatedPrice_Takbytte * 0.1);

        outputJson.Total_EstimatedPrice = outputJson.Buildings.reduce(
            (sum, building) => sum + (building.EstimatedPrice_Total || 0), 0
        );

        outputJson.JobSize = outputJson.Total_EstimatedPrice > 150000 ? 'Stor jobb' :
            outputJson.Total_EstimatedPrice > 50000 ? 'Medium jobb' : 'Liten jobb';

    }

    /**
     * Calculate roof metrics for a building
     * @param {Array} roofs - Array of roof facets for the building
     * * @returns {Object} - Object containing roofType, ComplexityScore, and AIConfidence
     */
    function calculateRoofMetrics(roofs, roofType) {
        if (!roofs || !roofs.length) {
            return {
                //roofType: 'Ukjent',
                ComplexityScore: 1.00,
                AIConfidence: 1.00
            };
        }

        // 1. Process facets and calculate basic metrics
        const facets = roofs.map(roof => ({
            area: parseFloat(roof.area) || 0,
            slope: parseFloat(roof.facetData?.Helning) || 0,
            direction: String(roof.facetData?.Retning || '').trim().toUpperCase()
        }));

        const totalArea = facets.reduce((sum, f) => sum + f.area, 0);
        const avgSlope = totalArea > 0 ?
            facets.reduce((sum, f) => sum + (f.slope * f.area), 0) / totalArea : 0;
        const maxSlope = facets.length ? Math.max(...facets.map(f => f.slope)) : 0;

        // 2. Calculate direction-based metrics
        const directions = facets.map(f => f.direction).filter(Boolean);
        const uniqueDirections = [...new Set(directions)];
        const OrientationCount = uniqueDirections.length;

        // 3. Calculate DominantPairShare
        const directionCounts = {};
        directions.forEach(dir => {
            directionCounts[dir] = (directionCounts[dir] || 0) + 1;
        });
        const maxCount = Math.max(...Object.values(directionCounts), 0);
        const DominantPairShare = facets.length > 0 ? maxCount / facets.length : 0;

        // 4. Calculate EffectiveTakflateCount
        let EffectiveTakflateCount;
        if (DominantPairShare >= 0.70 && OrientationCount <= 3) {
            EffectiveTakflateCount = 2;
        } else if (OrientationCount === 3 && facets.length >= 4 && avgSlope < 35) {
            EffectiveTakflateCount = 4;
        } else {
            EffectiveTakflateCount = Math.min(facets.length, 8);
        }

        // 5. Calculate EffectiveOrientationCount
        let EffectiveOrientationCount = 0;
        if (OrientationCount > 0) {
            const directionFrequencies = {};
            facets.forEach(f => {
                if (f.direction) {
                    directionFrequencies[f.direction] = (directionFrequencies[f.direction] || 0) + 1;
                }
            });
            EffectiveOrientationCount = Object.values(directionFrequencies)
                .filter(count => count >= 2).length;
            EffectiveOrientationCount = Math.max(2, EffectiveOrientationCount);
        } else {
            EffectiveOrientationCount = 2; // Default if no directions
        }

        // 6. Calculate SlopeVarFactor and HighSlopeFactor
        const SlopeSpread = Math.abs(maxSlope - avgSlope);
        const SlopeVarFactor = Math.min(SlopeSpread / Math.max(1, avgSlope), 1);
        const HighSlopeFactor = Math.max(0, Math.min((avgSlope - 30) / 40, 1));

        // 7. Determine roof type
        const hasArk = false; // Set based on your criteria
        const mansardHint = false; // Set based on your criteria
        const ConsistentSlopeShare = 1; // Default value, adjust based on your needs

        /*
        let roofType = 'Ukjent';

        if (facets.length === 1 && avgSlope < 5) {
            roofType = 'Flatt tak';
        } else if (facets.length === 1 && avgSlope >= 5) {
            roofType = 'Pulttak';
        } else if (hasArk && avgSlope >= 15 && avgSlope <= 45 && DominantPairShare >= 0.65) {
            roofType = 'Saltak med ark';
        } else if (avgSlope >= 15 && avgSlope <= 45 && OrientationCount <= 3 && DominantPairShare >= 0.70) {
            roofType = 'Saltak';
        } else if (OrientationCount >= 3 && facets.length >= 4 && avgSlope < 35 && !mansardHint) {
            roofType = 'Valmtak';
        } else if (OrientationCount >= 3 && facets.length >= 4 && (avgSlope >= 35 || mansardHint)) {
            roofType = 'Mansardtak';
        } else if ((EffectiveTakflateCount >= 3 && DominantPairShare >= 0.50 && DominantPairShare <= 0.75) ||
            (EffectiveOrientationCount === 3 && ConsistentSlopeShare >= 0.50)) {
            roofType = 'Kombinasjonstak';
        } else if (facets.length >= 8 && (EffectiveOrientationCount >= 4 || SlopeVarFactor >= 0.40) && DominantPairShare < 0.60) {
            roofType = 'Kompleks tak';
        }
         */

        // 8. Calculate ComplexityScore
        const FaktorFlater = 0.08 * Math.min(Math.max((EffectiveTakflateCount - 1) / 4, 0), 1);
        const FaktorRetninger = 0.06 * Math.min(Math.max((EffectiveOrientationCount - 1) / 3, 0), 1);
        const FaktorHelningsvar = 0.08 * (isNaN(SlopeVarFactor) ? 0 : SlopeVarFactor);
        const FaktorBratthet = 0.08 * (isNaN(HighSlopeFactor) ? 0 : HighSlopeFactor);
        const ContextBump = (roofType === 'Kombinasjonstak' || roofType === 'Kompleks tak') ? 0.05 : 0;

        let ComplexityScore = 1.00 + Math.min(
            0.30,
            FaktorFlater +
            FaktorRetninger +
            FaktorHelningsvar +
            FaktorBratthet +
            ContextBump
        );

        // Round to 2 decimal places
        ComplexityScore = Math.round(ComplexityScore * 100) / 100;

        // Calculate AIConfidence
        let AIConfidence = 0.50;

        // Check if we have all required data
        const hasRequiredData = facets.length > 0 && !isNaN(avgSlope) && directions.length > 0;

        // Calculate if we have a clear margin (more than 5 degrees from thresholds)
        const hasClearMargin = (value, threshold) => Math.abs(value - threshold) > 5;

        // Check if the current rule has a clear margin
        let clearMargin = false;

        // Apply confidence adjustments based on the selected roof type
        switch (roofType) {
            case 'Flatt tak':
                clearMargin = hasClearMargin(avgSlope, 5);
                break;
            case 'Pulttak':
                clearMargin = hasClearMargin(avgSlope, 5);
                break;
            case 'Saltak med ark':
                clearMargin = hasClearMargin(avgSlope, 15) && hasClearMargin(avgSlope, 45);
                break;
            case 'Saltak':
                clearMargin = hasClearMargin(avgSlope, 15) &&
                    hasClearMargin(avgSlope, 45) &&
                    hasClearMargin(DominantPairShare, 0.70);
                break;
            case 'Valmtak':
            case 'Mansardtak':
                clearMargin = hasClearMargin(avgSlope, 35);
                break;
            case 'Kombinasjonstak':
            case 'Kompleks tak':
                // These types are complex by nature, so we don't apply clear margin bonus
                break;
        }

        // Apply confidence adjustments
        if (clearMargin && hasRequiredData) {
            AIConfidence += 0.25;
        }

        // Bonus for high DominantPairShare or hasArk
        if (DominantPairShare >= 0.85 || hasArk) {
            AIConfidence += 0.10;
        }

        // Bonus for consistent slopes
        if (ConsistentSlopeShare >= 0.75) {
            AIConfidence += 0.10;
        }

        // Penalties
        // Check if slope is close to threshold
        const isNearThreshold = (value, threshold) => Math.abs(value - threshold) <= 2;
        if (isNearThreshold(avgSlope, 5) || isNearThreshold(avgSlope, 15) ||
            isNearThreshold(avgSlope, 35) || isNearThreshold(avgSlope, 45)) {
            AIConfidence -= 0.10;
        }

        // Penalty if directions are missing but required
        const directionsRequired = !['Flatt tak', 'Pulttak'].includes(roofType);
        if (directionsRequired && directions.length === 0) {
            AIConfidence -= 0.10;
        }

        // Penalty if description contradicts numbers
        // You'll need to implement the description check based on your requirements
        const descriptionContradicts = false; // Set based on your logic
        if (descriptionContradicts) {
            AIConfidence -= 0.15;
        }

        // Apply maximum limits based on data availability
        if (directions.length === 0 && uniqueDirections.length === 0) {
            AIConfidence = Math.min(AIConfidence, 0.65);
        }

        if (isNaN(avgSlope) && isNaN(maxSlope)) {
            AIConfidence = Math.min(AIConfidence, 0.60);
        }

        // Ensure confidence is within bounds
        AIConfidence = Math.max(0, Math.min(1, AIConfidence));

        // Round to 2 decimal places
        AIConfidence = Math.round(AIConfidence * 100) / 100;

        // Add AIConfidence to the return object
        return {
            //roofType,
            ComplexityScore,
            AIConfidence
        };
    }

    function getCalcCleaningPrice(area, complexity) {
        const rate = getCleaningRate(area);
        const raw = area * rate * complexity * getServiceDiscount(area);
        const total = Math.max(5000, raw);

        // round to nearest 100 NOK
        return Math.round(total / 100) * 100;
    }

    function getServiceDiscount(area) {
        if (area > 1000) {
            return 0.85;
        } else if (area > 500) {
            return 0.90;
        } else if (area > 300) {
            return 0.95;
        } else {
            return 1.00;
        }
    }

    function getCleaningRate(area) {
        if (area < 100) {
            return 70;
        }
        if (area < 200) {
            return 55;
        }
        if (area < 400) {
            return 50;
        }

        return 45;
    }
});